export default String.raw`
{% include 'partials/common/date-format.html' -%}

{% assign product = product-presentation.Product -%}
{% assign url = page.Url -%}

{% comment -%}<!-- Supplies -->{% endcomment -%}
{% assign suppliesSize = product.Supplies.Supplies | Size -%}
{% if product.Supplies != null and suppliesSize != 0 -%}
	{% comment -%}<!-- Keys -->{% endcomment -%}
	{% if page.QueryString contains 'keys' -%}
		{% assign queries = page.QueryString | Split:'&' -%}
		{% for query in queries -%}
			{% if query contains 'keys' -%}
				{% assign queryString = query | Split:'=' -%}
				{% assign joinedKeys = queryString[1] | Replace: '%2c', ',' -%}
				{% assign keys = joinedKeys | Split:',' -%}
			{% endif -%}
		{% endfor -%}
	{% else -%}
		{% if product.Supplies.Key != null -%}
			{% assign joinedKeys = product.Supplies.Key | Replace: '%2c', ',' -%}
			{% assign keys = joinedKeys | Split:',' -%}
		{% else -%}
			{% assign noParentSupply = product.Supplies.Supplies[0] -%}
			{% assign size = product.Supplies.AttributeNames | Size -%}
			{% for attribute in product.Supplies.AttributeNames -%}
				{% if forloop.index != 1 -%}
					{% assign noParentSupply = noParentSupply.Supplies[0] -%}
				{% endif -%}
				{% if forloop.index == size -%}
					{% assign joinedKeys = noParentSupply.Key | Replace: '%2c', ',' -%}
					{% assign keys = joinedKeys | Split:',' -%}
					{% assign noParentKey = true -%}
				{% endif -%}
			{% endfor -%}
		{% endif -%}
	{% endif -%}

	{% comment -%}<!-- Supply -->{% endcomment -%}
	{% assign supplies = product.Supplies.Supplies -%}
	{% for key in keys -%}
		{% for supply in supplies -%}
			{% if supply.ValueId == key -%}
				{% assign supplies = supply.Supplies -%}
				{% if supply.Key and product.Clip == true -%}
					{% assign supplyProduct = supply.Product -%}
				{% endif -%}
			{% endif -%}
		{% endfor -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Product -->{% endcomment -%}
{% if product.Clip or product.Batch -%}
	{% if product.Supplies != null and suppliesSize != 0 -%}
		{% assign suppliesAsNotSupplies = false -%}
	{% endif -%}
{% endif -%}
{% if suppliesAsNotSupplies == false and product.Clip -%}
	{% assign activeProduct = supplyProduct -%}
{% else -%}
	{% assign activeProduct = product -%}
{% endif -%}

{% comment -%}<!-- Attribute selection for flat structure -->{% endcomment -%}
{% unless product.Clip or product.Batch -%}
	{% comment -%}<!-- AttributeIds from QueryString -->{% endcomment -%}
	{% if page.QueryString contains 'attributeId' -%}
		{% assign queries = page.QueryString | Split:'&' -%}
		{% for query in queries -%}
			{% if query contains 'attributeId' -%}
				{% assign queryString = query | Split:'=' -%}
				{% assign joinedAttributeIds = queryString[1] | Replace: '%2c', ',' -%}
				{% assign attributeIds = joinedAttributeIds | Split:',' -%}
			{% endif -%}
		{% endfor -%}
	{% else -%}
		{% comment -%}<!-- Default attribute selection if none specified -->{% endcomment -%}
		{% if activeProduct.AttributesPolyvalent != null and activeProduct.AttributesPolyvalent | Size > 0 -%}
			{% assign joinedAttributeIds = '' -%}
			{% for attribute in activeProduct.AttributesPolyvalent -%}
				{% if attribute.Values != null and attribute.Values | Size > 0 -%}
					{% assign stringValue = attribute.Values[0].ValueId | ToString | Append: ',' -%}
					{% assign joinedAttributeIds = joinedAttributeIds | Append: stringValue -%}
				{% endif -%}
			{% endfor -%}
			{% assign attributeIds = joinedAttributeIds | Split: ',' -%}
		{% endif -%}
	{% endif -%}
{% endunless -%}

{% comment -%}<!-- Unit -->{% endcomment -%}
{% if page.QueryString contains 'unit' -%}
	{% assign queries = page.QueryString | Split:'&' -%}
	{% for query in queries -%}
		{% if query contains 'unit' -%}
			{% assign queryString = query | Split:'=' -%}
			{% assign queriesSize = queryString | Size -%}
			{% if queriesSize > 1 -%}
				{% assign unitId = queryString[1] -%}
			{% else -%}
				{% assign unitId = null -%}
			{% endif -%}
			{% for unit in activeProduct.Units -%}
				{% if unit.Id == unitId -%}
					{% assign unitDimensions = unit.Dimensions-%}
					{% assign unitRatio = unit.Ratio -%}
					{% assign unitName = unit.Name -%}
					{% assign unitMultiplicity = unit.Multiplicity -%}
					{% assign defaultUnit = unit.Default -%}
				{% endif -%}
			{% endfor -%}
		{% endif -%}
	{% endfor -%}
{% else -%}
	{% for unit in activeProduct.Units -%}
		{% if unit.Default == true or unit.Id == null -%}
			{% assign unitDimensions = unit.Dimensions-%}
			{% assign unitId = unit.Id -%}
			{% assign unitRatio = unit.Ratio -%}
			{% assign unitName = unit.Name -%}
			{% assign unitMultiplicity = unit.Multiplicity -%}
			{% assign defaultUnit = unit.Default -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Stock control ON and stock empty -->{% endcomment -%}
{% assign noProductOnControlledStock = false -%}
{% if activeProduct.StockLevel.QuantityControl == true and activeProduct.StockLevel.Value == 0 -%}
	{% assign noProductOnControlledStock = true -%}
{% else -%}
	{% assign noProductOnControlledStock = false -%}
{% endif -%}

{% comment -%}<!-- Show stock for not -->{% endcomment -%}
{% if config.Stock.Enabled == true -%}
	{% if usr.Authenticated == false and settings.notAuthStock == 'no' -%}
		{% assign showStock = false -%}
	{% else -%}
		{% assign showStock = true -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Current cart -->{% endcomment -%}
{% if customer.Carts[0] or customer.Cart.EditedOrderId -%}
	{% assign inquiryExists = false -%}
	{% assign lastCartId = -1 -%}
	{% for cart in customer.Carts -%}
		{% if cart.Current -%}
			{% assign currentCartId = cart.Id -%}
			{% assign currentCartName = cart.Name -%}
		{% endif -%}
		{% if cart.Inquiry -%}
			{% assign inquiryExists = true -%}
			{% assign inquiryId = cart.Id -%}
		{% else -%}
			{% assign lastCartId = cart.Id -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% comment -%}<!-- Reviews -->{% endcomment -%}
{% if config.Reviews.Enabled -%}
	{% if config.Reviews.AuthenticationRequired == false -%}
		{% assign canAddReview = true -%}
	{% elseif customer.Authenticated == true -%}
		{% assign canAddReview = true -%}
	{% else -%}
		{% assign canAddReview = false -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Comparer -->{% endcomment -%}
{% assign isInComparison = false -%}
{% for itemId in customer.ComparisonToolItems -%}
    {% if itemId == product-presentation.Product.Id -%}
        {% assign isInComparison = true -%}
    {% endif -%}
{% endfor -%}

{% comment -%}<!-- Table view -->{% endcomment -%}
{% if product.Archival == false -%}
	{% if suppliesAsNotSupplies == false or activeProduct.AttributesPolyvalent[0] -%}
		{% if activeProduct.AttributesPolyvalent[0] -%}
			{% if activeProduct.AskForPrice == false -%}
				{% assign tableView = true -%}
			{% else -%}
				{% if suppliesSize > 1 -%}
					{% assign tableView = true -%}
				{% else -%}
					{% if product.Clip == true -%}
						{% assign tableView = true -%}
					{% else -%}
						{% assign tableView = false -%}
					{% endif -%}
				{% endif -%}
			{% endif -%}
		{% else -%}
			{% assign tableView = true -%}
		{% endif -%}
	{% else -%}
		{% assign tableView = false -%}
	{% endif -%}
{% else -%}
	{% assign tableView = false -%}
{% endif -%}

{% comment -%}<!-- Graphical variants -->{% endcomment -%}
{% assign graphicalVariants = false -%}
{% if settings.grapicalVariantsPresentation != 'Variants_No' -%}
	{% assign graphicalVariants = true -%}
{% endif -%}

{% if graphicalVariants and settings.grapicalVariantsPresentation == 'Variants_Colors' %}
	{% assign lang = page.Language | Upcase -%}
	{% capture settingsKey -%}grapicalVariantsPresentationColors{{ lang }}{% endcapture -%}
	{% if settings[settingsKey] -%}
		{% assign colorVariants = settings[settingsKey] | Split: '|||' -%}
	{% else -%}
		{% assign colorVariants = settings.grapicalVariantsPresentationColorsDefault | Split: '|||' -%}
	{% endif -%}
{% endif -%}

{% if graphicalVariants %}
	{% assign graphicalVariantsLimit = 10 -%}
	{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
		{% assign graphicalVariantsLimit = 12 -%}
	{% elseif settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
		{% assign graphicalVariantsLimit = 7 -%}
	{% else settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
		{% assign graphicalVariantsLimit = 9 -%}
	{% endif -%}
{% endif -%}

{% comment -%}<!-- Product type -->{% endcomment -%}
{% if product.Batch -%}
	{% assign productType = 'batch' -%}
{% elsif product.Clip -%}
	{% assign productType = 'clip' -%}
{% else -%}
	{% assign productType = 'simple' -%}
{% endif -%}
<input type="hidden" name="productType" value="{{ productType }}">

{% comment -%}<!-- 360 photo link -->{% endcomment -%}
{% for attribute in product-presentation.Product.Attributes -%}
	{% assign attributeName = attribute.Name | Downcase -%}
	{% if attributeName contains '360photo' and attribute.Value != '' -%}
		<input type="hidden" id="parentPhotoLink" value="{{attribute.Value}}">
	{% endif -%}
{% endfor -%}

<div class="product-presentation__top-section {% if tableView -%} table-view {% endif -%}">
	<div class="gallery-container">
		{% assign stringIndexesOfMp4Videos = '' -%}
		{% for attachment in product.Attachments -%}
			{% if attachment.Extension == 'mp4' -%}
				{% assign stringCurrentIndex = forloop.index |Minus: 1 |ToString -%}
				{% assign stringIndexesOfMp4Videos = stringIndexesOfMp4Videos | Append: stringCurrentIndex | Append: ',' -%}
			{% endif -%}
		{% endfor -%}
		{% if stringIndexesOfMp4Videos != '' -%}
			{% assign indexesOfMp4Videos = stringIndexesOfMp4Videos | Split: ',' -%}
			{% assign indexesOfMp4VideosLength = indexesOfMp4Videos | Size -%}
		{% else -%}
			{% assign indexesOfMp4VideosLength = 0 -%}
		{% endif -%}
		{% assign imagesSize = activeProduct.ImagesExt | Size -%}
		{% assign parentProduct = product-presentation.Product -%}
		{% assign parentImagesSize = parentProduct.Images | Size -%}
		{% assign manyImages = false -%}
		{% if imagesSize > 1 or parentImagesSize > 1 or product.YouTubeVideos[0] or indexesOfMp4VideosLength > 0 -%}
			{% assign manyImages = true -%}
		{% endif -%}

		{% if settings.couponsPresentation == "yes" and settings.showCouponsOnProductsDetails == "yes" -%}
			{% assign showCouponsOnProductsDetails = true -%}
		{% endif -%}

		{% if activeProduct.HasCoupons and showCouponsOnProductsDetails -%}
			{% assign showCouponsPopup = true -%}
		{% endif -%}

		{% if showCouponsPopup -%}
			<div class="coupons-on-product-presentation coupons-on-product-presentation-js show-more-coupons-product-details-js {% if showCouponsOnProductsDetails -%} with-coupons-js {% endif -%}" data-id="{{ activeProduct.Id }}">
				<input type="hidden" name="productId" value="{{ activeProduct.Id }}" />
				<input type="hidden" name="productName" value="{{ activeProduct.NameNoHtml | H }}" />
				<input type="hidden" name="productCode" value="{{ activeProduct.Code | H }}" />
				{% if activeProduct.Image.Id > 0 and activeProduct.Image.Link != null -%}
					<input type="hidden" name="productImage" value="img/small/{{ activeProduct.Image.Id }}/{{ activeProduct.Image.Link }}" />
				{% elsif activeProduct.Image.ExternalUrl != null -%}
					<input type="hidden" name="productImage" value="{{ activeProduct.Image.ExternalUrl }}" />
				{% else -%}
					<input type="hidden" name="productImage" value="" />
				{% endif -%}
				
				<div class="product-coupons-skeleton-loader product-coupons-skeleton-loader-js">
					<div class="product-coupon-skeleton-item">
						<div class="skeleton-icon"></div>
						<div class="skeleton-content">
							<div class="skeleton-line skeleton-name"></div>
						</div>
					</div>
					<div class="product-coupon-skeleton-item">
						<div class="skeleton-icon"></div>
						<div class="skeleton-content">
							<div class="skeleton-line skeleton-name"></div>
						</div>
					</div>
					<div class="product-coupon-skeleton-item">
						<div class="skeleton-icon"></div>
						<div class="skeleton-content">
							<div class="skeleton-line skeleton-name"></div>
						</div>
					</div>
					<div class="product-coupon-skeleton-item">
						<div class="skeleton-icon"></div>
						<div class="skeleton-content">
							<div class="skeleton-line skeleton-name"></div>
						</div>
					</div>
				</div>
				
				<div class="product-coupons-items coupons-items-js"></div>
				
				<div class="show-more-button-container show-more-container-js" style="display: none;">
					<button class="pure-button show-more-coupons-btn show-more-coupons-product-list" type="button">
						{{ translations.ShowMoreDiscounts }} (<span class="total-count-js">0</span>)
					</button>
				</div>
			</div>
		{% endif -%}

		<div class="single-image single-image-js {% if imagesSize > 0 -%} with-no-image {% endif -%}">
			<button class="close-popup close-zoom-js hidden-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
			{% if manyImages -%}
				<div class="single-image__swiper swiper">
					<div class="swiper-wrapper zoom-btn-js" tabindex="0" role="button" aria-label="{{ translations.ZoomImage }}">
			{% endif -%}
			{% include 'partials/product/product-gallery.html' with activeProduct, isMulti: false -%}
			{% if indexesOfMp4VideosLength > 0 -%}
				{% for indexOfMp4Video in indexesOfMp4Videos -%}
					<video class="swiper-slide {% if manyImages == false -%}zoom-btn-js" aria-label="{{ translations.ZoomImage }}" role="button"{% else -%}"{% endif -%} {% if manyImages == false -%}tabindex="0"{% endif -%} width="100%" height="100%" controls="" name="media">
						{% assign mp4VideoIndex = indexOfMp4Video | ToInt -%}
						<source src="{{product.Attachments[mp4VideoIndex].Url}}" type="video/mp4">
						Your browser does not support the video tag.
					</video>
				{% endfor -%}
			{% endif -%}
			{% if product.YouTubeVideos[0] -%}
				{% for video in product.YouTubeVideos -%}
					<div class="swiper-slide {% if manyImages == false -%}zoom-btn-js" aria-label="{{ translations.ZoomImage }}" role="button"{% else -%}"{% endif -%} {% if manyImages == false -%}tabindex="0"{% endif -%}>
						<iframe width="100%" height="100%" title="{{ video.Name }}" src="{{ video.Url }}" allowfullscreen></iframe>
					</div>
				{% endfor -%}
			{% endif -%}
			{% if manyImages -%}
					</div>
					<div class="swiper-pagination"></div>
				</div>
				<div aria-label="{{translations.PrevSlide}}" tabindex="0" role="button" class="single-image__prev arrow shadowed change-slide-js">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
				<div aria-label="{{translations.NextSlide}}" tabindex="0" role="button" class="single-image__next arrow shadowed change-slide-js">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
			{% endif -%}
			{% for attribute in product.Attributes -%}
				{% assign attributeName = attribute.Name | Downcase -%}
				{% if attributeName contains '360photo' -%}
					{% if attribute.Value != '' -%}
						<input type="hidden" class="photoLink" value="{{attribute.Value}}">
						<div class="open360 open360-js open-popup-with-form" data-popup-class=".image-rotate-popup" data-product-list="true">
							<svg>
								<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#360'></use>
							</svg>
						</div>
					{% endif -%}
				{% endif -%}
			{% endfor -%}
			{% if settings.showRotateImageOnList == 'showRotateImageOnList-yes' -%}
				{% for attribute in product.AttributesList.Attributes -%}
					{% assign attributeName = attribute.Name | Downcase -%}
					{% if attributeName contains '360photo' -%}
						{% if attribute.Values[0].Value != '' -%}
                            {% assign is360photo = true -%}
							<input type="hidden" class="photoLink" value="{{attribute.Values[0].Value}}">
						{% endif -%}
					{% endif -%}
				{% endfor -%}

                {% if is360photo == true -%}
                    <div class="open360 open360-js open-popup-with-form" data-popup-class=".image-rotate-popup" data-product-list="true">
                        <svg>
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#360'></use>
                        </svg>
                    </div>
                {% endif -%}
			{% endif -%}
			<div class='gallery-container__flags'>
				{% if product.Archival -%}
					<div class="ribbon archival">{{ translations.ArchivalProduct}}</div>
				{% endif -%}
				{% for flag in product.Flags limit:3 -%}
					<div class="ribbon {{flag.Type}}">
						{% if flag.Type == "Reward" -%}
							{{ translations.PointsProduct }}
						{% else -%}
							{{ flag.Text }}
						{% endif -%}
					</div>
				{% endfor %}
			</div>
		</div>
		{% if manyImages -%}
			<div class="multi-image">
				<div aria-label="{{translations.PrevSlide}}" tabindex="0" role="button" class="multi-image__prev arrow shadowed">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
				<div aria-label="{{translations.NextSlide}}" tabindex="0" role="button" class="multi-image__next arrow shadowed">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
				<div thumbsSlider="" class="multi-image__swiper swiper">
					<div class="swiper-wrapper">
						{% include 'partials/product/product-gallery.html' with activeProduct, isMulti: true -%}
						{% if product.YouTubeVideos[0] -%}
							{% for video in product.YouTubeVideos -%}
								<div class="swiper-slide" tabindex="0">
									<iframe tabindex="-1" width="100%" height="100%" title="{{ video.Name }}" src="{{ video.Url }}&autohide=1"></iframe>
									<div class="video-tile youtube">
									</div>
								</div>
							{% endfor -%}
						{% endif -%}
						{% if indexesOfMp4VideosLength > 0 -%}
							{% for indexOfMp4Video in indexesOfMp4Videos -%}
								<div class="swiper-slide" tabindex="0">
									<video tabindex="-1" class="swiper-slide" width="100%" height="100%" controls="" name="media">
										{% assign mp4VideoIndex = indexOfMp4Video | ToInt -%}
										<source src="{{product.Attachments[mp4VideoIndex].Url}}" type="video/mp4">
										<img title="Your browser does not support the video tag.">
									</video>
									<div class="video-tile">
										<svg class="play-video">
											<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#play-circle-{{ settings.iconStyle }}"></use>
										</svg>
									</div>
								</div>
							{% endfor -%}
						{% endif -%}
					</div>
				</div>
			</div>
		{% endif -%}
	</div>

	<div class="product-name-container">
		<h1 class="product-name-container__product-name">{{ activeProduct.NameNoHtml | H }}</h1>
		{% assign twoColumns = false -%}
		{% if config.Products.ShowCode and activeProduct.Code != '' -%}
			{% assign twoColumns = true -%}
		{% endif -%}
		{% if product.Archival == false and tableView -%}
			{% unless settings.showAvailabilityStatus == 'no' and product.Availability.Status == 1 -%}
				{% if product.Availability.ImageUrl != '' and product.Availability.Type != 3 -%}
					{% assign twoColumns = true -%}
				{% endif -%}
				{% if product.Availability.Type != 2 -%}
					{% if product.Availability.Status == 0 or product.Availability.Status == 2 -%}
						{% assign twoColumns = true -%}
					{% elseif product.Availability.Status == 1 -%}
						{% assign twoColumns = true -%}
					{% elseif product.Availability.Status == 3 -%}
						{% assign twoColumns = true -%}
					{% endif -%}
				{% endif -%}
			{% endunless -%}
			{% if product.Availability.Date and product.Availability.Status == 0 -%}
				{% assign twoColumns = true -%}
			{% endif -%}
		{% endif -%}
		<div class="product-name-container__buttons-container {% if twoColumns -%} two-columns {% endif -%}">
			<div class="product-code-and-availability-container">
				{% if config.Products.ShowCode and activeProduct.Code != '' -%}
					<div class="product-code">{{ translations.ProductCode }}: <strong class="product-code-js">{{ activeProduct.Code | H }}</strong>
						<button aria-label="{{ translations.AfterCopyMessage }}" class="copy-js" data-text="{{ activeProduct.Code | H }}">
							<svg width="20" height="20">
								<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#copy-{{settings.iconStyle}}'></use>
							</svg>
						</button>
					</div>
				{% endif -%}
				{% if product.Archival == false and tableView and graphicalVariants == false -%}
					{% unless settings.showAvailabilityStatus == 'no' and activeProduct.Availability.Status == 1 -%}
						<div class="availability">
							{% if activeProduct.Availability.ImageUrl != '' and activeProduct.Availability.Type != 3 -%}
								<img alt="{{ activeProduct.Availability.Text }}" src="css/img/alo.gif" data-src="{{ activeProduct.Availability.ImageUrl }}"> 
								{% if activeProduct.Availability.Type == 2 -%}
									{{translations.Availability}}
								{% endif -%}
							{% endif -%}
							{% if activeProduct.Availability.Type != 2 -%}
								{% if activeProduct.Availability.Status == 0 or activeProduct.Availability.Status == 2 -%}
									{{activeProduct.Availability.Text}}
								{% elseif activeProduct.Availability.Status == 1 -%}
									{{translations.Available}}
									{% if settings.showAvailabilityStatus == 'yes' and activeProduct.Availability.Text != '' -%}
										{{activeProduct.Availability.Text | Downcase}}
									{% endif -%}
								{% elseif activeProduct.Availability.Status == 3 -%}
									{{translations.NotAvailable}}
								{% endif -%}
							{% endif -%}
						</div>
					{% endunless -%}
					{% if activeProduct.Availability.Date and activeProduct.Availability.Status == 0 -%}
						<div>{{translations.PreviewDate}}: {{activeProduct.Availability.Date | Date: dateFormat}}</div>
					{% endif -%}
				{% endif -%}
			</div>
			<div class="buttons">
				{% if settings.printBtnShowHide == 'printBtnShowHide-yes' -%}
					<button aria-label="{{translations.printPage}}" class="pure-button print-js">
						<svg class="pure-button__icon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#print-{{settings.iconStyle}}"></use>
						</svg>
						<span class="pure-button__text">{{translations.printPage}}</span>
					</button>
				{% endif -%}
				{% if settings.shareProducts == 'share-yes' -%} 
					<div>
					<button aria-label="{{ translations.ShareProduct }}" class="pure-button share-product share-product-js opening-modal-mobile-js" data-template="partials/product/share-product.html" data-container=".share-product-dropdown-js">
						<svg class="pure-button__icon">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#share-alt-{{settings.iconStyle}}"></use>
						</svg>
						<span class="pure-button__text">{{ translations.ShareProduct }}</span>
					</button>
					<div class="share-product-dropdown share-product-dropdown-js">
						{% comment -%}<!-- Form loaded after click -->{% endcomment -%}
						</div>
					</div>
				{% endif -%}
				{% if product.Archival == false -%}
					{% if product-presentation.Product.Supervisor -%}
						{% if settings.showProductGuardian == 'only-authenticated' and customer.Authenticated -%}
							{% assign showProductGuardian = true -%}
						{% endif -%}
						{% if settings.showProductGuardian == 'yes' or showProductGuardian -%}
							{% assign showProductGuardianFinal = true -%}
						{% endif -%}
						{% if showProductGuardianFinal -%}
							{% assign supervisor = product-presentation.Product.Supervisor -%}
							<button class="pure-button supervisor-js load-product-presentation-form-js opening-modal-mobile-js" {% if settings.showGuardianNameAs != 'nothing' -%} title="{{supervisor.FirstName}} {% if settings.showGuardianNameAs == 'name-and-surname' -%}{{supervisor.LastName}}{% endif -%}" {% endif -%} data-template="partials/product/product-presentation-forms.html" data-container=".ask-about-product-js" data-url="{{ url }}" data-include="ask-supervisor">
								<svg class="pure-button__icon">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
								</svg>
								<div class="supervisor__title pure-button__text">
									<span>{{translations.AskGuardian}}</span>
									{% if settings.showGuardianPhoneNo == 'yes' and supervisor.PhoneNo != '' -%}
										{% assign showSupervisorPhone = true -%}
									{% endif -%}
									{% if settings.showGuardianPhoneNo == 'main-phone' and config.Shop.Contact.PhoneNo != '' -%}
										{% assign showMainPhone = true -%}
									{% endif -%}
									{% if showSupervisorPhone or showMainPhone -%}
										<div class="phone">
											{% if showSupervisorPhone -%}
												<a class="phone" href="tel:{{supervisor.PhoneNo}}">({{supervisor.PhoneNo}})</a>
											{% else -%}
												<a class="phone" href="tel:{{config.Shop.Contact.PhoneNo}}">({{config.Shop.Contact.PhoneNo}})</a>
											{% endif -%}
										</div>
									{% endif -%}
								</div>
							</button>
						{% endif -%}
					{% endif -%}
					{% if product-presentation.Product.Supervisor == null or showProductGuardianFinal != true -%}
						<button aria-label="{{ translations.AskAboutProduct }}" class="pure-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".ask-about-product-js" data-url="{{ url }}" data-include="ask-about-product">
							<svg class="pure-button__icon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
							</svg>
							<span class="pure-button__text">{{ translations.AskAboutProduct }}</span>
						</button>
					{% endif -%}
					<div class="ask-about-product-js container-js">
						{% comment -%}<!-- Form loaded after click -->{% endcomment -%}
					</div>
				{% endif -%}
			</div>
		</div>
	</div>
	<div class="main-content-container {% if tableView == false or graphicalVariants == true -%} simple-product {% endif -%} ">
		{% if product.Archival == false -%}
			<div class="main-content-container__prices-and-more-container add-to-cart-form-container-js form-js add-to-cart-js need-product-id-js container-js" data-include="add-to-cart">
				<input type="hidden" name="__action" value="Cart/Add" >
				<input type="hidden" name="__template" value="partials/product/product-presentation-data.html" >
				<input name="unitId" type="hidden" value="{{ unitId }}">
				{% if config.Products.AIEnabled == true -%}
					<input id="sourceToAdd-js" name="source" type="hidden" value=""/>
				{% endif -%}
				{% if settings.productIsInCart == 'productIsInCart-yes' -%}
					<input type="hidden" id="isInCartId" value="{{activeProduct.Id}}">
				{% endif -%}
				<div class="prices-container product-container-js">
					{% if activeProduct.AskForPrice == false -%}
						{% if tableView == true and graphicalVariants == false -%}
						{% else -%}
							{% if customer.HidePrices -%}
								<div class="label sign-in">
									<div class="label__icon">
										<svg width="16" height="19">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
										</svg>
									</div>
									<span class="label__text">{{translations.SignInToSeePrice}}</span>
								</div>
								{% if activeProduct.PreviousPrice != null and customer.HidePrices -%}
									{% if customer.Cart.SubtotalPrices -%}
										{% assign whatPrice = translations.Netto | Downcase -%}
										<div class="prices-container__suggested"><span class="value">{{ activeProduct.SubtotalPreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
									{% else -%}
										{% assign whatPrice = translations.Brutto | Downcase -%}
										<div class="prices-container__suggested"><span class="value">{{ activeProduct.TotalPreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}</div>
									{% endif -%}
								{% endif -%}
							{% else -%}
								{% if settings.thresholds == 'yes' and activeProduct.HasThresholds and activeProduct.Price != null -%}
									{% assign whatPrice = translations.Brutto | Downcase -%}
									{% if customer.Cart.SubtotalPrices -%}
										{% assign whatPrice = translations.Netto | Downcase -%}
									{% endif -%}
									{% assign firstThreshold = activeProduct.Thresholds | First -%}
									{% assign lastThreshold = activeProduct.Thresholds | Last -%}
									<div class="prices-container__label">{{ translations.Price }} {{ whatPrice }}</div>
									<div class="prices-container__range">
										{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
									</div>
									{% assign thresholdsSize = activeProduct.Thresholds | Size -%}
									{% if thresholdsSize >= 2 -%}
										<button class="prices-container__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">
											<span>{{ translations.SeePriceDetails }}</span>
										</button>
										<div class="popup-background hidden-js hide-js container-to-hide-js">
											<div class="popup thresholds-popup">
												<div class="popup__header">
													<div class="title">{{ translations.PriceDetails }}</div>
													<svg class="hide-container-js">
														<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
													</svg>
												</div>
												<div class="popup__content">
													<div class="name">{{ activeProduct.Name }}</div>
													<div class="thresholds">
														<div class="thresholds__row">
															<span>{{ translations.Quantity }} [{{ activeProduct.SaleUnit }}]:</span>
															<span>{{ translations.Price }} {{ whatPrice }}:</span>
														</div>
														{% for threshold in activeProduct.Thresholds -%}
															<div class="thresholds__row">
																<div>{{ threshold.Threshold | Normalize }}+</div>
																<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
															</div>
														{% endfor %}
													</div>
												</div>
											</div>
										</div>
									{% endif -%}
								{% else -%}
									{% if config.ENTERPRISE -%}
										{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
											{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
												{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
													{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
														<div class="prices-container__default-unit-price-container">
															{{ activeProduct.TotalPrice | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }}/{{product.SaleUnit}}
														</div>
													{% endif -%}
												{% else -%}
													{% if activeProduct.BasicUnit != unitName -%}
														<div class="prices-container__default-unit-price-container">
															{{ activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }}/{{product.BasicUnit}}
														</div>
													{% endif -%}
												{% endif -%}
											{% endif -%}
											<div class="prices-container__price-container">
												<span class="price brutto-js" data-brutto-price="{{activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio  | Round: config.DecimalPlacesPrice }}">
													{% assign totalPrice = activeProduct.TotalPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign totalPriceStr = totalPrice | ToString -%}
													{% assign totalPriceArr = totalPriceStr | Split:config.DecimalSeparator -%}
													{% if totalPriceStr contains config.DecimalSeparator -%}
														{% assign totalPriceDecSize = totalPriceArr[1] | Size | Plus:1 -%}
														{% if totalPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (totalPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign totalPriceStr = totalPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign totalPrice = totalPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ totalPrice }} {{ currencyExt }}
												</span>
												{% if activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
													<span class="previous brutto-previous-js" data-bruttoprevious-price="{{activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign totalPrevPrice = activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
														{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
														{% if totalPrevPriceStr contains config.DecimalSeparator -%}
															{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
															{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign totalPrevPrice = totalPrevPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ totalPrevPrice }} {{ currencyExt }}
													</span>
												{% elseif activeProduct.TotalRegularPrice > activeProduct.TotalPrice and activeProduct.TotalRegularPrice != null and settings.lowestProductPrice == 'no' -%}
													<span class="previous brutto-previous-js" data-bruttoprevious-price="{{activeProduct.TotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
														{% assign totalPrevPrice = activeProduct.TotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
														{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
														{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
														{% if totalPrevPriceStr contains config.DecimalSeparator -%}
															{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
															{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
																{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																	{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
																{% endfor -%}
																{% assign totalPrevPrice = totalPrevPriceStr -%}
															{% endif -%}
														{% endif -%}
														{{ totalPrevPrice }} {{ currencyExt }}
													</span>
												{% endif -%}
												<span class="label">{{ translations.Brutto | Downcase }}</span>
											</div>
											{% if activeProduct.DepositValue > 0 -%}
												<div class="prices-container__deposit-container">
													<span class="price deposit-js" data-deposit-price="{{ activeProduct.DepositValue | Round: config.DecimalPlacesPrice }}">
														+ {{ translations.Com_Deposit }}: {{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
													</span>
												</div>
											{% endif -%}
											{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null -%}
												<div class="prices-container__lowest-price brutto-lowest-js" data-bruttolowest-price="{{activeProduct.TotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
													{% assign totalMinPrice = activeProduct.TotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign totalMinPriceStr = totalMinPrice | ToString -%}
													{% assign totalMinPriceArr = totalMinPriceStr | Split:config.DecimalSeparator -%}
													{% if totalMinPriceStr contains config.DecimalSeparator -%}
														{% assign totalMinPriceDecSize = totalMinPriceArr[1] | Size | Plus:1 -%}
														{% if totalMinPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (totalMinPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign totalMinPriceStr = totalMinPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign totalMinPrice = totalMinPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ totalMinPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }} - {{translations.Price_Omnibus}}
												</div>
											{% endif -%}
											{% if activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and activeProduct.TotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
												<div class="prices-container__lowest-price brutto-lowest-js" data-bruttolowest-price="{{activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
													{% assign totalPrevPrice = activeProduct.TotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign totalPrevPriceStr = totalPrevPrice | ToString -%}
													{% assign totalPrevPriceArr = totalPrevPriceStr | Split:config.DecimalSeparator -%}
													{% if totalPrevPriceStr contains config.DecimalSeparator -%}
														{% assign totalPrevPriceDecSize = totalPrevPriceArr[1] | Size | Plus:1 -%}
														{% if totalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (totalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign totalPrevPriceStr = totalPrevPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign totalPrevPrice = totalPrevPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ totalPrevPrice }} {{ currencyExt }} {{ translations.Brutto | Downcase }} - {{translations.SuggestedRetailPrice}}
												</div>
											{% endif -%}
											{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
												{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
													{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
														<div class="prices-container__default-unit-price-container">
															{{ activeProduct.SubtotalPrice | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }}/{{activeProduct.SaleUnit}}
														</div>
													{% endif -%}
												{% else -%}
													{% if activeProduct.BasicUnit != unitName -%}
														<div class="prices-container__default-unit-price-container">
															{{ activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }}/{{activeProduct.BasicUnit}}
														</div>
													{% endif -%}
												{% endif -%}
											{% endif -%}
										{% endunless -%}
										<div class="prices-container__price-container">
											<span class="price netto-js" data-netto-price="{{activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
												{% assign subtotalPrice = activeProduct.SubtotalPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
												{% assign subtotalPriceStr = subtotalPrice | ToString -%}
												{% assign subtotalPriceArr = subtotalPriceStr | Split:config.DecimalSeparator -%}
												{% if subtotalPriceStr contains config.DecimalSeparator -%}
													{% assign subtotalPriceDecSize = subtotalPriceArr[1] | Size | Plus:1 -%}
													{% if subtotalPriceDecSize <= config.DecimalPlacesPrice -%}
														{% for i in (subtotalPriceDecSize..config.DecimalPlacesPrice) -%}
															{% assign subtotalPriceStr = subtotalPriceStr | Append:'0' -%}
														{% endfor -%}
														{% assign subtotalPrice = subtotalPriceStr -%}
													{% endif -%}
												{% endif -%}
												{{ subtotalPrice }} {{ currencyExt }}
											</span>
											{% if activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
												<span class="previous netto-previous-js" data-nettoprevious-price="{{activeProduct.SubtotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
													{% assign subtotalPrevPrice = activeProduct.SubtotalPreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
													{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
													{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
														{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
														{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ subtotalPrevPrice }} {{ currencyExt }}
												</span>
											{% elseif activeProduct.SubtotalRegularPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalRegularPrice != null and settings.lowestProductPrice == 'no' -%}
												<span class="previous netto-previous-js" data-nettoprevious-price="{{activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
													{% assign subtotalPrevPrice = activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
													{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
													{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
														{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
														{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ subtotalPrevPrice }} {{ currencyExt }}
												</span>
											{% endif -%}
											<span class="label">{{ translations.Netto | Downcase }}</span>
										</div>
										{% if activeProduct.DepositValue > 0 -%}
											<div class="prices-container__deposit-container">
												<span class="price deposit-js" data-deposit-price="{{ activeProduct.DepositValue | Round: config.DecimalPlacesPrice }}">
													+ {{ translations.Com_Deposit }}: {{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
												</span>
											</div>
										{% endif -%}
										{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null -%}
											<div class="prices-container__lowest-price netto-lowest-js" data-nettolowest-price="{{activeProduct.SubtotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
												{% assign subtotalMinPrice = activeProduct.SubtotalMinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
												{% assign subtotalMinPriceStr = subtotalMinPrice | ToString -%}
												{% assign subtotalMinPriceArr = subtotalMinPriceStr | Split:config.DecimalSeparator -%}
												{% if subtotalMinPriceStr contains config.DecimalSeparator -%}
													{% assign subtotalMinPriceDecSize = subtotalMinPriceArr[1] | Size | Plus:1 -%}
													{% if subtotalMinPriceDecSize <= config.DecimalPlacesPrice -%}
														{% for i in (subtotalMinPriceDecSize..config.DecimalPlacesPrice) -%}
															{% assign subtotalMinPriceStr = subtotalMinPriceStr | Append:'0' -%}
														{% endfor -%}
														{% assign subtotalMinPrice = subtotalMinPriceStr -%}
													{% endif -%}
												{% endif -%}
												{{ subtotalMinPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }} - {{translations.Price_Omnibus}}
											</div>
										{% endif -%}
										{% if activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and activeProduct.SubtotalPreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
											<div class="prices-container__lowest-price netto-lowest-js" data-netto-lowest="{{activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
												{% assign subtotalPrevPrice = activeProduct.SubtotalRegularPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
												{% assign subtotalPrevPriceStr = subtotalPrevPrice | ToString -%}
												{% assign subtotalPrevPriceArr = subtotalPrevPriceStr | Split:config.DecimalSeparator -%}
												{% if subtotalPrevPriceStr contains config.DecimalSeparator -%}
													{% assign subtotalPrevPriceDecSize = subtotalPrevPriceArr[1] | Size | Plus:1 -%}
													{% if subtotalPrevPriceDecSize <= config.DecimalPlacesPrice -%}
														{% for i in (subtotalPrevPriceDecSize..config.DecimalPlacesPrice) -%}
															{% assign subtotalPrevPriceStr = subtotalPrevPriceStr | Append:'0' -%}
														{% endfor -%}
														{% assign subtotalPrevPrice = subtotalPrevPriceStr -%}
													{% endif -%}
												{% endif -%}
												{{ subtotalPrevPrice }} {{ currencyExt }} {{ translations.Netto | Downcase }} - {{translations.SuggestedRetailPrice}}
											</div>
										{% endif -%}
									{% else -%}
										{% assign whatPrice = translations.Brutto | Downcase -%}
										{% if customer.Cart.SubtotalPrices -%}
											{% assign whatPrice = translations.Netto | Downcase -%}
										{% endif -%}
										{% if settings.showUnitRateOnProductDetailsPage == 'yes' %}
											{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
												{% if activeProduct.Units[1] and defaultUnit == false and unitId != null -%}
													<div class="prices-container__default-unit-price-container">
														{{ activeProduct.Price | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ whatPrice }}/{{activeProduct.SaleUnit}}
													</div>
												{% endif -%}
											{% else -%}
												{% if activeProduct.BasicUnit != unitName -%}
													<div class="prices-container__default-unit-price-container">
														{{ activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} {{ whatPrice }}/{{activeProduct.BasicUnit}}
													</div>
												{% endif -%}
											{% endif -%}
										{% endif -%}
										<div class="prices-container__price-container">
											<span class="price {{whatPrice}}-js" data-{{whatPrice}}-price="{{activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
												{% assign price = activeProduct.Price | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
												{% assign priceStr = price | ToString -%}
												{% assign priceArr = priceStr | Split:config.DecimalSeparator -%}
												{% if priceStr contains config.DecimalSeparator -%}
													{% assign priceDecSize = priceArr[1] | Size | Plus:1 -%}
													{% if priceDecSize <= config.DecimalPlacesPrice -%}
														{% for i in (priceDecSize..config.DecimalPlacesPrice) -%}
															{% assign priceStr = priceStr | Append:'0' -%}
														{% endfor -%}
														{% assign price = priceStr -%}
													{% endif -%}
												{% endif -%}
												{{ price }} {{ currencyExt }}
											</span>
											{% if activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice != 'yes' -%}
												<span class="previous {{whatPrice}}-previous-js" data-{{whatPrice}}previous="{{activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
													{% assign prevPrice = activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
													{% assign prevPriceStr = prevPrice | ToString -%}
													{% assign prevPriceArr = prevPriceStr | Split:config.DecimalSeparator -%}
													{% if prevPriceStr contains config.DecimalSeparator -%}
														{% assign prevPriceDecSize = prevPriceArr[1] | Size | Plus:1 -%}
														{% if prevPriceDecSize <= config.DecimalPlacesPrice -%}
															{% for i in (prevPriceDecSize..config.DecimalPlacesPrice) -%}
																{% assign prevPriceStr = prevPriceStr | Append:'0' -%}
															{% endfor -%}
															{% assign prevPrice = prevPriceStr -%}
														{% endif -%}
													{% endif -%}
													{{ prevPrice }} {{ currencyExt }}
												</span>
											{% endif -%}
											<span class="label">{{ whatPrice }}</span>
										</div>
										{% if activeProduct.DepositValue > 0 -%}
											<div class="prices-container__deposit-container">
												<span class="price deposit-js" data-deposit-price="{{ activeProduct.DepositValue | Round: config.DecimalPlacesPrice }}">
													+ {{ translations.Com_Deposit }}: {{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
												</span>
											</div>
										{% endif -%}
										{% if settings.lowestProductPrice == 'yes' and activeProduct.MinPrice > 0 and activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null -%}
											<div class="prices-container__lowest-price {{ whatPrice }}-lowest-js" data-{{ whatPrice }}lowest-price="{{activeProduct.MinPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice }}">
												{% assign minPrice = activeProduct.MinPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
												{% assign minPriceStr = minPrice | ToString -%}
												{% assign minPriceArr = minPriceStr | Split:config.DecimalSeparator -%}
												{% if minPriceStr contains config.DecimalSeparator -%}
													{% assign minPriceDecSize = minPriceArr[1] | Size | Plus:1 -%}
													{% if minPriceDecSize <= config.DecimalPlacesPrice -%}
														{% for i in (minPriceDecSize..config.DecimalPlacesPrice) -%}
															{% assign minPriceStr = minPriceStr | Append:'0' -%}
														{% endfor -%}
														{% assign minPrice = minPriceStr -%}
													{% endif -%}
												{% endif -%}
												{{ minPrice }} {{ currencyExt }} {{ whatPrice }} - {{translations.Price_Omnibus}}
											</div>
										{% endif -%}
										{% if activeProduct.PreviousPrice > activeProduct.Price and activeProduct.PreviousPrice != null and settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
											{% assign prevPrice = activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice -%}
											{% assign prevPriceStr = prevPrice | ToString -%}
											{% assign prevPriceArr = prevPriceStr | Split:config.DecimalSeparator -%}
											{% if prevPriceStr contains config.DecimalSeparator -%}
												{% assign prevPriceDecSize = prevPriceArr[1] | Size | Plus:1 -%}
												{% if prevPriceDecSize <= config.DecimalPlacesPrice -%}
													{% for i in (prevPriceDecSize..config.DecimalPlacesPrice) -%}
														{% assign prevPriceStr = prevPriceStr | Append:'0' -%}
													{% endfor -%}
													{% assign prevPrice = prevPriceStr -%}
												{% endif -%}
											{% endif -%}
											<div class="prices-container__lowest-price {{ whatPrice }}-lowest-js" data-{{ whatPrice }}lowest-price="{{activeProduct.PreviousPrice | DividedBy: activeProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice}}">
												{{ prevPrice }} {{ currencyExt }} {{ whatPrice }} - {{translations.SuggestedRetailPrice}}
											</div>
										{% endif -%}
									{% endif -%}
								{% endif -%}
								{% if activeProduct.UnitPriceUnit != null -%}
									<div class="prices-container__unit-price">
										{{ activeProduct.Price | Times: activeProduct.UnitPriceRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} {% if customer.Cart.SubtotalPrices -%}{{ translations.Netto | Downcase }}{% else -%}{{ translations.Brutto | Downcase }}{% endif -%}/{{ activeProduct.UnitPriceUnit }}
									</div>
								{% endif -%}
								{% if customer.HidePrices or product.Price == null -%}
									{% assign noPrices = true -%}
								{% else -%}
									{% assign noPrices = false -%}
								{% endif -%}
								{% if noPrices == false and usr.Authenticated and activeProduct.PointsPrice != null and product.Batch == false and product.Clip == false -%}
									{% assign pointsPrice = activeProduct.PointsPrice -%}
									<div class="prices-container__points-price">
										<svg>
											<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#gift-card-{{settings.iconStyle}}'></use>
										</svg>
										<span data-basic="{{ product.PointsPrice }}" class="amount">{{ translations.PayViaLoyaltyPoints }} - <strong>{{ pointsPrice }} {{ translations.PointsShortcut }}</strong></span>
									</div>
								{% endif -%}
							{% endif -%}
							<div class="prices-container__availability-container">
								{% unless settings.showAvailabilityStatus == 'no' and activeProduct.Availability.Status == 1 -%}
									<div class="availability">
										{% if activeProduct.Availability.ImageUrl != '' and activeProduct.Availability.Type != 3 -%}
											<img alt="{{ activeProduct.Availability.Text }}" src="css/img/alo.gif" data-src="{{ activeProduct.Availability.ImageUrl }}"> 
											{% if activeProduct.Availability.Type == 2 -%}
												{{translations.Availability}}
											{% endif -%}
										{% endif -%}
										{% if activeProduct.Availability.Type != 2 -%}
											{% if activeProduct.Availability.Status == 0 or activeProduct.Availability.Status == 2 -%}
												{{activeProduct.Availability.Text}}
											{% elseif activeProduct.Availability.Status == 1 -%}
												{{translations.Available}}
												{% if settings.showAvailabilityStatus == 'yes' and activeProduct.Availability.Text != '' -%}
													{{activeProduct.Availability.Text | Downcase}}
												{% endif -%}
											{% elseif activeProduct.Availability.Status == 3 -%}
												{{translations.NotAvailable}}
											{% endif -%}
										{% endif -%}
									</div>
								{% endunless -%}
								{% if activeProduct.Availability.Date and activeProduct.Availability.Status == 0 -%}
									<div>{{translations.PreviewDate}}: {{activeProduct.Availability.Date | Date: dateFormat}}</div>
								{% endif -%}
							</div>
							{% if activeProduct.StockLevel.Control and showStock -%}
								<div class="prices-container__stock-container">
									{% assign isTitle = false -%}
									{% if activeProduct.StockLevel.Type == 1 and activeProduct.StockLevel.Text != '' -%}
										{% assign isTitle = true -%}
									{% endif -%}
									{% if tableView == false -%}
										{% if activeProduct.StockLevel.ImageUrl -%}
											{% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 2 -%}
												<img alt="{{ activeProduct.StockLevel.Text }}" src="css/img/alo.gif" data-src="{{activeProduct.StockLevel.ImageUrl}}" {% if isTitle -%} title="{{ activeProduct.StockLevel.Text }}" {% endif -%} >
											{% endif -%}
										{% endif -%}

										<div class="stock">
											{{translations.InStock}}: {% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 3 -%}{{ activeProduct.StockLevel.Text }}{% elseif activeProduct.StockLevel.Type == 4 -%}{{ activeProduct.StockLevel.Value | Normalize }}{% endif %}
										</div>
									{% elseif graphicalVariants == true -%}
										{% if product.Clip or product.Batch -%}
											{% assign supplies = product.Supplies.Supplies -%}
											{% assign suppliesSize = product.Supplies.Supplies | Size -%}
											{% assign levelsQuantity = product.Supplies.AttributeNames | Size -%}

											{% if suppliesSize > 0 -%}
												{% for firstLevelSupply in supplies -%}
													{% include 'partials/product/find-variant-product.html' with currentSupply: firstLevelSupply, depth: 1, maxDepth: levelsQuantity -%}

													{% if dataKeys == joinedKeys -%}
														{% break -%}
													{% endif -%}
												{% endfor -%}
											{% endif -%}
										{% else -%}
											{% assign supplyStockLevel = activeProduct.StockLevel -%}
										{% endif -%}

										{% if supplyStockLevel.ImageUrl -%}
											{% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 2 -%}
												<img alt="{{ supplyStockLevel.Text }}" src="css/img/alo.gif" data-src="{{supplyStockLevel.ImageUrl}}" {% if isTitle -%} title="{{ supplyStockLevel.Text }}" {% endif -%} >
											{% endif -%}
										{% endif -%}

										<div class="stock">
											{{translations.InStock}}: {% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 3 -%}{{ supplyStockLevel.Text }}{% elseif supplyStockLevel.Type == 4 -%}{{ supplyStockLevel.Value | Normalize }}{% endif %}
										</div>
									{% endif -%}
								</div>
							{% endif -%}
						{% endif -%}
					{% endif -%}

					{% if tableView == false -%}
						{% unless activeProduct.AskForPrice == true -%}
							<div class="prices-container__quantity-container">
								{% include 'partials/product/amount-stepper.html' with activeProduct -%}
								{% assign showBasicUnitInfo = false -%}
								{% if settings.showUnitRateOnProductDetailsPageUnit == 'basic' and activeProduct.BasicUnit != unitName -%}
									{% assign showBasicUnitInfo = true -%}
								{% endif -%}
								<span class="unit-container" data-unit="{{unitId}}" data-unit-ratio-info="{{showBasicUnitInfo}}" data-basic-unit-ratio="{{activeProduct.BasicUnitRatio}}">
									{% if activeProduct.Units[1] -%}
										<div tabindex="0" class="unit-container__units select select-js">
											<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
												{% for unit in activeProduct.Units -%}
													{% if unit.Id == unitId -%}
														{% assign defaultUnitName = unit.Name -%}
													{% endif -%}
													<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
												{% endfor -%}
											</select>
											<div class="select__input">
												<span class="selected-js">
													{{ defaultUnitName | H }}
												</span>
												<svg>
													<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
												</svg>
											</div>
											<ul class="select__options options-js">
												{% for unit in activeProduct.Units -%}
													<li tabindex="-1" class="parent-container-reload-js replace-template-js reset-units-js" data-url="{{ url }}?unit={{ unit.Id }}" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}">{{ unit.Name | H }}</li>
												{% endfor -%}
											</ul>
											<input id="unit-dimensions-{{ activeProduct.Id }}" class="dimensions-js" type="hidden"
											{% for unit in activeProduct.Units -%}
												{% assign dimensionsByUnitIndex = unit.Dimensions  -%}
												data-unit{{unit.Id}}="{{dimensionsByUnitIndex.Height}}|{{dimensionsByUnitIndex.Length}}|{{dimensionsByUnitIndex.Width}}"
											{% endfor -%}>
										</div>
										<div class="unit-container__unit-ratio-info">
											{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
												{% assign productUnitsSize = activeProduct.Units | Size -%}
												{% for unit in activeProduct.Units -%}
													{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
														{% if unit.Id != unitId -%}
															<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: activeProduct.BasicUnitRatio | Round: 4 }} {{ activeProduct.SaleUnit }}</span>
														{% endif -%}
													{% else -%}
														{% if unit.Name != activeProduct.BasicUnit -%}
															<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{activeProduct.BasicUnit}}</span>
														{% endif -%}
													{% endif -%}
												{% endfor -%}
											{% endif -%}
										</div>
									{% else -%}
										{{ activeProduct.SaleUnit }}
									{% endif -%}
								</span>
							</div>
							{% if activeProduct.BasicUnitMinQuantity > 1 -%}
								<div class="min-quantity-info">
									<svg>
										<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
									</svg>
									<span>
										{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
									</span>
								</div>
							{% endif -%}
						{% endunless -%}
					{% endif -%}

					{% if activeProduct.Availability.Status == 3 -%}
						{% assign notifyMe = true -%}
					{% else -%}
						{% assign notifyMe = false -%}
					{% endif -%}
					
					{% if product.Clip or product.Batch -%}
						{% if graphicalVariants == true -%}
							{% assign supplies = product.Supplies.Supplies -%}
							{% assign suppliesSize = product.Supplies.Supplies | Size -%}

							{% if suppliesSize > 0 -%}
								{% assign levelsQuantity = product.Supplies.AttributeNames | Size -%}
								{% assign firstLevelName = product.Supplies.AttributeNames[0].Name -%}

								{% comment -%}<!-- Render level zero with images, show first image of the subtree -->{% endcomment -%}
								<div class="graphical-variants__container">

									{% comment -%}<!-- Name of current selected value -->{% endcomment -%}
									{% assign key = keys[0] -%}
									{% for firstLevelSupply in supplies -%}
										{% if firstLevelSupply.ValueId == key -%}
											{% assign firstLevelValue = firstLevelSupply.Value -%}
										{% endif -%}
									{% endfor -%}
									<p class="name">{{ firstLevelName }}: <span class="value">{{firstLevelValue}}</span></p>
									<div class="graphical-variants">
										{% for firstLevelSupply in supplies -%}
											{% comment -%}
												<!-- Recursive get the first available child product (for image rendering on the first level) -->
												<!-- Returns: foundProduct, dataKeys and supplyStockLevel (batch product case) -->
											{% endcomment -%}

											{% include 'partials/product/find-variant-product.html' with currentSupply: firstLevelSupply, depth: 1, maxDepth: levelsQuantity -%}

											{% assign noSupplyProductOnControlledStock = false -%}
											{% if supplyStockLevel.QuantityControl == true and supplyStockLevel.Value == 0 -%}
												{% assign noSupplyProductOnControlledStock = true -%}
											{% else -%}
												{% assign noSupplyProductOnControlledStock = false -%}
											{% endif -%}

											<div class="graphical-variant graphical-variant-js value {% if forloop.index > graphicalVariantsLimit -%} hidden-js {% endif -%} {% if firstLevelSupply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js {% if levelsQuantity != 1 %} not-last-lvl-js {% else -%} child-js child-reload-js change-parent-js {% endif -%} {% if noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} unavailable {% endif -%} {% if foundProduct.AskForPrice or noSupplyProductOnControlledStock or foundProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if foundProduct.AttributesEditable[0] or foundProduct.AttributesPolyvalent[0] -%} with-attributes {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" {% if levelsQuantity == 1 %} data-child-index="{{ forloop.index0 }}" data-supply-id="{{ firstLevelSupply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ foundProduct.ImageId }}/.jpg" data-code="{{ foundProduct.Code }}" data-weight="{{ foundProduct.Weight }}" data-netweight="{{ foundProduct.NetWeight}}" {% endif -%}>
												{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
													{% assign anyColor = false -%}
													{% for firstLevelSupply in supplies -%}
														{% for color in colorVariants -%}
															{% assign colorArr = color | Split: '||' -%}

															{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
															{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
															{% assign colorDowncase = colorArr[0] | Downcase -%}
															
															{% if colorDowncase == valueDowncase -%}
																{% assign anyColor = true -%}
																{% break -%}
															{% endif -%}
														{% endfor -%}
													{% endfor -%}
												
													{% assign colorHex = '#FFFFFF' -%}
													{% for color in colorVariants -%}
														{% assign colorArr = color | Split: '||' -%}

														{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
														{% assign valueDowncase = firstLevelSupply.Value | Downcase -%}
														{% assign colorDowncase = colorArr[0] | Downcase -%}

														{% if colorDowncase == valueDowncase -%}
															{% assign colorHex = colorArr[1] -%}
															{% break -%}
														{% endif -%}
													{% endfor -%}

													{% comment %} <!-- Color representation --> {% endcomment %}
													<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
														<input tabindex="-1" type="radio" name="attributeId" value="{{firstLevelSupply.ValueId}}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
														{% if anyColor -%}
															<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
																{% if colorHex == 'multicolor' %}
																	<foreignObject x="4" y="4" width="32" height="32">
																		<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
																	</foreignObject>
																{% else %}
																	<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
																{% endif %}
															</svg>
														{% else -%}
															{{firstLevelSupply.Value}}
														{% endif -%}
													</label>
												{% elseif settings.grapicalVariantsPresentation == 'Variants_Thumbnails' -%}
													{% comment %} <!-- Thumbnail representation --> {% endcomment %}
													<label tabindex="0" class="chip chip--thumbnail">
														<input tabindex="-1" type="radio" name="attributeId" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
															{% if firstLevelSupply.ValueId == key and activeProduct.Image -%}
																{{activeProduct | Img }}
															{% elseif foundProduct.Image -%}
																{{ foundProduct | Img }}
															{% else -%}
																<img width="52" height="52" src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}"/>
															{% endif -%}
													</label>
												{% elseif settings.grapicalVariantsPresentation == 'Variants_DropDownList' -%}
													{% comment %} <!-- Normal chip --> {% endcomment %}
													<label tabindex="0" class="chip chip--default">
														<input tabindex="-1" type="radio" name="attributeId" value="{{ firstLevelSupply.ValueId }}" {% if firstLevelSupply.ValueId == key -%} checked {% endif -%}>
														{{firstLevelSupply.Value}}
													</label>
												{% endif -%}

												{% if firstLevelSupply.ValueId == key -%}
													{% assign activeSupplies = firstLevelSupply.Supplies -%}
													{% if dataKeys == joinedKeys and levelsQuantity == 1  -%}
														<input name="supplyId" type="hidden" value="{{ firstLevelSupply.SupplyId }}">
														{% for keyVal in keys -%}
															<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
														{% endfor -%}
													{% endif -%}
												{% endif -%}
											</div>
										{% endfor -%}
										{% assign showMoreCount = suppliesSize | Minus: graphicalVariantsLimit -%}
										{% if showMoreCount > 0 -%}
											<button class="open-variants-popup-js pure-button chip chip--showMore">{{translations.More}} +{{ showMoreCount }}
											</button>
										{% endif -%}

										{% if suppliesSize > graphicalVariantsLimit -%}
											{% include 'partials/product/graphical-variant-popup.html' -%}
										{% endif -%}
									</div>

									{% comment -%}<!-- Render the rest of the tree from the first level -->{% endcomment -%}
									{% assign otherLevels = product.Supplies.AttributeNames | Skip: 1 %}
									{% assign levelsQuantity = levelsQuantity | Minus: 1 -%}
									{% assign supplies = activeSupplies -%}

									{% for attribute in otherLevels -%}
										{% assign lvl = forloop.index -%}
										{% if lvl != levelsQuantity -%}
											<div class="attributes__not-last-level-attribute">
												{% comment -%}<!-- Level name -->{% endcomment -%}
												<div class="name">{{ attribute.Name }}</div>

												{% comment -%}<!-- Level values-->{% endcomment -%}
												<div class="values">
													{% assign key = keys[forloop.index] -%}
													
													{% for supply in supplies -%}
														{% if supply.Key -%}
															{% assign dataKeys = supply.Key -%}
														{% else -%}
															{% assign childs = supply.Supplies -%}
															{% assign size = keys | Size -%}
															{% assign end = size | Minus: lvl -%}
															{% for lvl in (1..end) -%}
																{% for child in childs -%}
																	{% if child.ValueId == childs[0].ValueId -%}
																		{% unless child.Key -%}
																			{% assign childs = child.Supplies -%}
																		{% else -%}
																			{% assign dataKeys = child.Key -%}
																		{% endunless -%}
																		{% break -%}
																	{% endif -%}
																{% endfor -%}
															{% endfor -%}
														{% endif -%}

														<button class="value {% if supply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js not-last-lvl-js" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}">
															{{ supply.Value }}

															{% if supply.ValueId == key -%}
																{% assign supplies = supply.Supplies -%}
																{% if supply.Key == joinedKeys -%}
																	<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
																	{% for keyVal in keys -%}
																		<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
																	{% endfor -%}
																{% endif -%}
															{% endif -%}
														</button>
													{% endfor -%}
												</div>
											</div>
										{% else -%}
											<div class="attributes__not-last-level-attribute">
												{% comment -%}<!-- Last level name -->{% endcomment -%}
												<div class="name">{{ attribute.Name }}</div>

												{% comment -%}<!-- Last level values-->{% endcomment -%}
												<div class="values">
													{% assign key = keys[forloop.index] -%}
													
													{% for supply in supplies -%}
														{% if supply.Key -%}
															{% assign dataKeys = supply.Key -%}
														{% else -%}
															{% assign childs = supply.Supplies -%}
															{% assign size = keys | Size -%}
															{% assign end = size | Minus: lvl -%}
															{% for lvl in (1..end) -%}
																{% for child in childs -%}
																	{% if child.ValueId == childs[0].ValueId -%}
																		{% unless child.Key -%}
																			{% assign childs = child.Supplies -%}
																		{% else -%}
																			{% assign dataKeys = child.Key -%}
																		{% endunless -%}
																		{% break -%}
																	{% endif -%}
																{% endfor -%}
															{% endfor -%}
														{% endif -%}

														{% if product.Clip -%}
															{% assign supplyProduct = supply.Product -%}
														{% elseif product.Batch -%}
															{% assign supplyProduct = product -%}
														{% endif -%}

														{% for unit in supplyProduct.Units -%}
															{% if unit.Default == true or unit.Id == null -%}
																{% assign supplyUnitId = unit.Id -%}
																{% assign supplyUnitRatio = unit.Ratio -%}
																{% assign supplyUnitName = unit.Name -%}
																{% assign defaultSupplyUnit = unit.Default -%}
															{% endif -%}
														{% endfor -%}

														{% assign supplyStockLevel = supply.StockLevel -%}
														{% assign noSupplyProductOnControlledStock = false -%}
														{% if supplyProduct.StockLevel.QuantityControl == true and supplyProduct.StockLevel.Value == 0 -%}
															{% assign noSupplyProductOnControlledStock = true -%}
														{% else -%}
															{% assign noSupplyProductOnControlledStock = false -%}
														{% endif -%}

														<button class="value {% if supply.ValueId == key -%} active-js {% endif -%} {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} child-js child-reload-js parent-container-reload-js change-parent-js {% if supplyProduct.AskForPrice or noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%} with-attributes {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
															{{ supply.Value }}

															{% if supply.ValueId == key -%}
																{% assign supplies = supply.Supplies -%}
																{% if supply.Key == joinedKeys -%}
																	<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
																	{% for keyVal in keys -%}
																		<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{keyVal}}">
																	{% endfor -%}
																{% endif -%}
															{% endif -%}
														</button>
													{% endfor -%}
												</div>
											</div>
										{% endif -%}
									{% endfor -%}	

									{% comment -%} <!-- Attributes editable and polyvalent --> {% endcomment -%}
									{% if activeProduct.AttributesEditable[0] or activeProduct.AttributesPolyvalent[0] -%}
										<div class="graphical-variants__attributes attributes-container-js">
											<div class="last-level-attribute__more-attributes">
												<div class="attr-container">
													{% if activeProduct.AttributesEditable[0] -%}
														{% for attrEditable in activeProduct.AttributesEditable -%}
															<div class="attribute-editable attribute-container-js">
																<input name="attributeId" type="hidden" value="{{ attrEditable.Id }}">
																<div class="form__input-wrapper">
																	{% case attrEditable.Format -%}
																		{% when 1 -%}
																			<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																			<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																			<div class="form__input-value--clear-button">
																				<svg width="16" height="16">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																				</svg>
																			</div>	
																		{% when 2 -%}
																			<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																			<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
																		{% when 3 -%}
																			<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																			<div tabindex="0" class="select select-js">
																				<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																					{% for val in attrEditable.Values %}
																						<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																					{% endfor -%}
																				</select>
																				<div class="select__input">
																					<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																						{{ attrEditable.Values[0].Value }}
																					</span>
																					<svg width="16" height="16">
																						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																					</svg>
																				</div>
																				<ul class="select__options options-js">
																					{% for val in attrEditable.Values %}
																						<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																					{% endfor -%}
																				</ul>
																			</div>
																		{% when 4 -%}
																			<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																			<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
																	{% endcase -%}
																	<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																		{{ translations.FillAttributeValue }}
																	</div>
																</div>
															</div>
														{% endfor -%}
													{% endif -%}
													{% if activeProduct.AttributesPolyvalent[0] -%}
														{% for attrPolyvalent in activeProduct.AttributesPolyvalent -%}
															<div class="attribute-editable attribute-container-js">
																<div class="form__input-wrapper">
																	<span class="form__input-info input-info-js on-label">{{ attrPolyvalent.Name }}</span>
																	<div tabindex="0" class="select select-js">
																		<select aria-label="{{ attrPolyvalent.Name }}" class="memory-js" name="attributePolyvalent">
																			{% for val in attrPolyvalent.Values %}
																				<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																			{% endfor -%}
																		</select>
																		<div class="select__input">
																			<span class="selected-js" title="{{ attrPolyvalent.Values[0].Value }}">
																				{{ attrPolyvalent.Values[0].Value }}
																			</span>
																			<svg width="16" height="16">
																				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																			</svg>
																		</div>
																		<ul class="select__options options-js">
																			{% for val in attrPolyvalent.Values %}
																				<li tabindex="-1" data-name="attributePolyvalent" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																			{% endfor -%}
																		</ul>
																	</div>
																	<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																		{{ translations.FillAttributeValue }}
																	</div>
																</div>
															</div>
														{% endfor -%}
													{% endif -%}
												</div>
											</div>
										</div>
									{% endif -%}

									{% comment -%}<!-- Quantity and unit selection -->{% endcomment -%}
									{% assign noActiveProductOnControlledStock = false -%}
									{% if activeProduct.StockLevel.QuantityControl == true and activeProduct.StockLevel.Value == 0 -%}
										{% assign noActiveProductOnControlledStock = true -%}
									{% else -%}
										{% assign noActiveProductOnControlledStock = false -%}
									{% endif -%}

									{% for unit in activeProduct.Units -%}
										{% if unit.Default == true or unit.Id == null -%}
											{% assign activeProductUnitId = unit.Id -%}
											{% assign activeProductUnitRatio = unit.Ratio -%}
											{% assign activeProductUnitName = unit.Name -%}
											{% assign defaultSupplyUnit = unit.Default -%}
										{% endif -%}
									{% endfor -%}


									{% if noActiveProductOnControlledStock == false and activeProduct.AskForPrice == false and activeProduct.Availability.Status != 3 -%}
										<div class="graphical-variants__quantity-unit">
											<div class="quantity-column graphical-variants__quantity ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ activeProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{activeProduct.Id}}">
												{% if product.Clip -%}
													{% include 'partials/product/amount-stepper.html' with activeProduct -%}
												{% elseif product.Batch -%}
													{% include 'partials/product/amount-stepper.html' with activeProduct.StockLevel -%}
												{% endif -%}

												{% assign unitRatioInfo = false -%}
												{% if settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and activeProductUnitName != activeProduct.BasicUnit -%}
													{% assign unitRatioInfo = true -%}
												{% endif -%}
											</div>
											<div class="unit-column graphical-variants__unit unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{activeProduct.BasicUnitRatio}}">
												{% if activeProduct.Units[1] -%}
													<div tabindex="0" class="unit-column__units select select-js child-select-js">
														<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
															{% for unit in activeProduct.Units -%}
																{% if unit.Id == unitId -%}
																	{% assign defaultUnitName = unit.Name -%}
																{% endif -%}
																<option value="{{ unit.Id }}" {% if unit.Id == activeProductUnitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
															{% endfor -%}
														</select>
														<div class="select__input">
															<span class="selected-js">
																{{ defaultUnitName | H }}
															</span>
															<svg>
																<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
															</svg>
														</div>
														<ul class="select__options options-js units-in-table-js">
															{% for unit in activeProduct.Units -%}
																<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
															{% endfor -%}
														</ul>
														<input id="unit-dimensions-{{ activeProduct.Id }}" class="dimensions-js" type="hidden"
														{% for unit in activeProduct.Units -%}
															{% assign dimensionsByUnitIndex = unit.Dimensions  -%}
															data-unit{{unit.Id}}="{{dimensionsByUnitIndex.Height}}|{{dimensionsByUnitIndex.Length}}|{{dimensionsByUnitIndex.Width}}"
														{% endfor -%}>
													</div>
													<div class="unit-column__unit-ratio-info">
														{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
															{% assign productUnitsSize = activeProduct.Units | Size -%}
															{% for unit in activeProduct.Units -%}
																{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																	{% if unit.Id != activeProductUnitId -%}
																		<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: activeProductUnitRatio | Round: 4 }} {{ activeProductUnitName }}</span>
																	{% endif -%}
																{% else -%}
																	{% if unit.Name != activeProduct.BasicUnit -%}
																		<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{activeProduct.BasicUnit}}</span>
																	{% endif -%}
																{% endif -%}
															{% endfor -%}
														{% endif -%}
													</div>
												{% else -%}
													{{ activeProductUnitName }}
												{% endif -%}
												{% if activeProduct.BasicUnitMinQuantity > 1 -%}
													<div class="min-quantity-info phantom">
														<svg>
															<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
														</svg>
														<span>
															{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
														</span>
													</div>
												{% endif -%}
											</div>
										</div>
									{% endif -%}
								</div>
							{% endif -%}
						{% else -%}
							{% assign supplies = product.Supplies.Supplies -%}
							{% assign suppliesSize = product.Supplies.Supplies | Size -%}
							{% if suppliesSize > 0 -%}
								{% for attribute in product.Supplies.AttributeNames -%}
									{% assign lvl = forloop.index -%}
									{% assign levelsQuantity = product.Supplies.AttributeNames | Size -%}
									{% if lvl != levelsQuantity -%}
										<div class="attributes__not-last-level-attribute">
											<div class="name">{{ attribute.Name }}</div>
											<div class="values">
												{% assign key = keys[forloop.index0] -%}
												{% for supply in supplies -%}
													{% if supply.Key -%}
														{% assign dataKeys = supply.Key -%}
													{% else -%}
														{% assign childs = supply.Supplies -%}
														{% assign size = keys | Size -%}
														{% assign end = size | Minus: lvl -%}
														{% for lvl in (1..end) -%}
															{% for child in childs -%}
																{% if child.ValueId == childs[0].ValueId -%}
																	{% unless child.Key -%}
																		{% assign childs = child.Supplies -%}
																	{% else -%}
																		{% assign dataKeys = child.Key -%}
																	{% endunless -%}
																	{% break -%}
																{% endif -%}
															{% endfor -%}
														{% endfor -%}
													{% endif -%}
													<button aria-label="attribute-button" class="value {% if supply.ValueId == key -%} active-js {% endif -%} parent-container-reload-js not-last-lvl-js" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}">
														{{ supply.Value }}
													</button>
													{% if supply.ValueId == key -%}
														{% assign supplies = supply.Supplies -%}
														{% if supply.Key == joinedKeys -%}
															<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}">
															{% for keyVal in keys -%}
																<input name="attributeId" type="hidden" value="{{ keyVal }}">
															{% endfor -%}
														{% endif -%}
													{% endif -%}
												{% endfor -%}
											</div>
										</div>
									{% else -%}
										<div class="attributes__table-container">
											<table>
												<colgroup>
													<col style="width: 100px;">
													<col style="width: 150px;">
													{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<col style="width: 150px;">{% endunless -%}
													<col style="width: 150px;">
												</colgroup>
												<thead>
													<tr>
														<th class="name-column attribute-name-js">{{ attribute.Name }}</th>
														{% if config.ENTERPRISE -%}
															<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
															{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<th class="brutto-price-column">{{ translations.TotalPrice }}</th>{% endunless -%}
														{% else -%}
															{% if customer.Cart.SubtotalPrices -%}
																<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
															{% else -%}
																<th class="brutto-price-column">{{ translations.TotalPrice }}</th>
															{% endif -%}
														{% endif -%}
														{% if product.StockLevel != null and showStock -%}
															<th class="stock-column">{{ translations.Stock }}</th>
														{% endif -%}
														<th class="quantity-column">{{ translations.Quantity }}</th>
														<th class="unit-column">{{ translations.Unit }}</th>
													</tr>
												</thead>
												<tbody>
													{% assign key = keys[forloop.index0] -%}
													{% for supply in supplies -%}
														{% if supply.Key -%}
															{% assign dataKeys = supply.Key -%}
														{% else -%}
															{% assign childs = supply.Supplies -%}
															{% assign size = keys | Size -%}
															{% assign end = size | Minus: lvl -%}
															{% for lvl in (1..end) -%}
																{% for child in childs -%}
																	{% if child.ValueId == childs[0].ValueId -%}
																		{% unless child.Key -%}
																			{% assign childs = child.Supplies -%}
																		{% else -%}
																			{% assign dataKeys = child.Key -%}
																		{% endunless -%}
																		{% break -%}
																	{% endif -%}
																{% endfor -%}
															{% endfor -%}
														{% endif -%}

														{% if product.Clip -%}
															{% assign supplyProduct = supply.Product -%}
														{% elseif product.Batch -%}
															{% assign supplyProduct = product -%}
														{% endif -%}

														{% assign supplyStockLevel = supply.StockLevel -%}

														{% for unit in supplyProduct.Units -%}
															{% if unit.Default == true or unit.Id == null -%}
																{% assign supplyUnitId = unit.Id -%}
																{% assign supplyUnitRatio = unit.Ratio -%}
																{% assign supplyUnitName = unit.Name -%}
																{% assign defaultSupplyUnit = unit.Default -%}
															{% endif -%}
														{% endfor -%}

														{% assign noSupplyProductOnControlledStock = false -%}
														{% if supplyProduct.StockLevel.QuantityControl == true and supplyProduct.StockLevel.Value == 0 -%}
															{% assign noSupplyProductOnControlledStock = true -%}
														{% else -%}
															{% assign noSupplyProductOnControlledStock = false -%}
														{% endif -%}
														<tr tabindex="0" class="last-level-attribute {% if supply.ValueId == key -%} active-js {% endif -%} {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} child-js child-reload-js parent-container-reload-js {% if supplyProduct.AskForPrice or noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} ask-for-price-child-js {% endif -%} {% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%} with-attributes expandable-mechanism-container-js {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
															<td class="name-column supply-value-js">
																{{ supply.Value }}
																{% if supplyProduct.AskForPrice == false -%}
																	{% if noSupplyProductOnControlledStock == false and supplyProduct.Availability.Status != 3 -%}
																		{% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%}
																			<button class="pure-button expand-data-js change-arrow-title-js" title="{{ translations.ShowDetails }}">
																				{{ translations.ShowDetails }} 
																				<svg height="16" width="16" class="icon rotate-down dropdown-arrow">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
																				</svg>
																			</button>
																		{% endif -%}
																	{% endif -%}
																{% endif -%}
															</td>
															{% assign supplyUnitsSize = supplyProduct.Units | Size -%}
															{% if settings.thresholds == 'yes' and supplyProduct.HasThresholds and supplyProduct.Price != null and supplyUnitsSize == 1 -%}
																<td class="thresholds-column" {% if config.ENTERPRISE -%} colspan="2" {% endif -%}>
																	{% assign whatPrice = translations.Brutto | Downcase -%}
																	{% if customer.Cart.SubtotalPrices -%}
																		{% assign whatPrice = translations.Netto | Downcase -%}
																	{% endif -%}
																	{% assign firstThreshold = supplyProduct.Thresholds | First -%}
																	{% assign lastThreshold = supplyProduct.Thresholds | Last -%}
																	<div class="thresholds-column__label">{{ translations.Price }} {{ whatPrice }}</div>
																	<div class="thresholds-column__range">
																		{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
																	</div>
																	{% assign thresholdsSize = supplyProduct.Thresholds | Size -%}
																	{% if thresholdsSize >= 2 -%}
																		<button class="thresholds-column__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">{{ translations.SeePriceDetails }}</button>
																		<div class="popup-background hidden-js hide-js container-to-hide-js">
																			<div class="popup thresholds-popup">
																				<div class="popup__header">
																					<div class="title">{{ translations.PriceDetails }}</div>
																					<svg class="hide-container-js">
																						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																					</svg>
																				</div>
																				<div class="popup__content">
																					<div class="name">{{ supplyProduct.Name }}</div>
																					<div class="thresholds">
																						<div class="thresholds__row">
																							<span>{{ translations.Quantity }} [{{ supplyUnitName }}]:</span>
																							<span>{{ translations.Price }} {{ whatPrice }}:</span>
																						</div>
																						{% for threshold in supplyProduct.Thresholds -%}
																							<div class="thresholds__row">
																								<div>{{ threshold.Threshold | Normalize }}+</div>
																								<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
																							</div>
																						{% endfor %}
																					</div>
																				</div>
																			</div>
																		</div>
																	{% endif -%}
																</td>
															{% elseif config.ENTERPRISE -%}
																<td class="netto-price-column" data-netto-price="{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																	{% if supplyProduct.SubtotalPrice != null -%}
																		{% if customer.HidePrices == false -%}
																			<span class="netto-price-column__price">
																				<span class="netto-js">
																					{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																				</span>
																				<span class="price">{{ currencyExt }}</span>
																				{% if supplyProduct.SubtotalPreviousPrice != null and supplyProduct.SubtotalPreviousPrice > supplyProduct.SubtotalPrice -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																						<div class="netto-price-column__lowest-price netto-previous-js"  data-nettoprevious-price="{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																					{% else -%}
																						<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																							<span class="netto-previous-js">{{ supplyProduct.SubtotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																						</div>
																					{% endif -%}
																				{% elseif supplyProduct.SubtotalRegularPrice != null and supplyProduct.SubtotalRegularPrice > supplyProduct.SubtotalPrice and settings.lowestProductPrice == 'no' -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.SubtotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																						<span class="netto-previous-js">{{ supplyProduct.SubtotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																					</div>
																				{% endif -%}
																			</span>
																			{% if supplyProduct.DepositValue > 0 -%}
																				<span class="netto-price-column__deposit-price">
																					<span>+ {{translations.Com_Deposit}}: </span>
																					<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																						{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																					</span>
																				</span>
																			{% endif -%}
																		{% endif -%}
																		{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] and customer.HidePrices == false %}
																			{% for unit in supplyProduct.Units -%}
																				{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																					{% if unit.Id != supplyUnitId -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																						</div>
																					{% endif -%}
																				{% else -%}
																					{% if unit.Name != supplyProduct.BasicUnit -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ supplyProduct.SubtotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																						</div>
																					{% endif -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endif -%}
																		{% if supplyProduct.SubtotalPreviousPrice != null and supplyProduct.SubtotalPreviousPrice > supplyProduct.SubtotalPrice and settings.lowestProductPrice == 'yes' -%}
																			<div class="netto-price-column__lowest-price netto-lowest-js">{{ supplyProduct.SubtotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																		{% endif -%}
																	{% elseif customer.HidePrices -%}
																		<div class="label sign-in">
																			<div class="label__icon">
																				<svg width="16" height="19">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																				</svg>
																			</div>
																			<span class="label__text">{{translations.SignInToSeePrice}}</span>
																		</div>
																		<div class="prices-container__suggested">
																		{% if supplyProduct.SubtotalPreviousPrice != null -%}
																			{% assign whatPrice = translations.Netto | Downcase -%}
																			<span class="value">{{ supplyProduct.SubtotalPreviousPrice }} {{ currencyExt }}</span> {{ whatPrice }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																		{% endif -%}
																		</div>
																	{% else -%}
																		<button aria-label="ask-for-price" style="gap:8px;" class="pure-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
																			{{ translations.AskForPrice }}
																			<svg width="20" height="20" class="primary-action-button__icon">
																				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																			</svg>
																		</button>
																	{% endif -%}
																</td>
																{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																	<td class="brutto-price-column" data-brutto-price="{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																		{% if supplyProduct.TotalPrice != null -%}
																			{% if customer.HidePrices == false -%}
																				<span class="brutto-price-column__price">
																					<span class="brutto-js">
																						{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																					</span>
																					<span class="price">{{ currencyExt }}</span>
																					{% if supplyProduct.TotalPreviousPrice != null and supplyProduct.TotalPreviousPrice > supplyProduct.TotalPrice -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																							<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																						{% else -%}
																							<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																								<span class="brutto-previous-js">{{ supplyProduct.TotalPreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																							</div>
																						{% endif -%}
																					{% elseif supplyProduct.TotalRegularPrice != null and supplyProduct.TotalRegularPrice > supplyProduct.TotalPrice and settings.lowestProductPrice == 'no' -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.TotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio }}">
																							<span class="brutto-previous-js">{{ supplyProduct.TotalRegularPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																						</div>
																					{% endif -%}
																				</span>
																				{% if supplyProduct.DepositValue > 0 -%}
																					<span class="brutto-price-column__deposit-price">
																						<span>+ {{translations.Com_Deposit}}: </span>
																						<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																							{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																						</span>
																					</span>
																				{% endif -%}
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] and customer.HidePrices == false %}
																				{% for unit in supplyProduct.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != supplyUnitId -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != supplyProduct.BasicUnit -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.TotalPrice | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																				{% if supplyProduct.TotalPreviousPrice != null and supplyProduct.TotalPreviousPrice > supplyProduct.TotalPrice and settings.lowestProductPrice == 'yes' -%}
																					<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ supplyProduct.TotalMinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																				{% endif -%}
																			{% endunless -%}
																		{% elseif customer.HidePrices -%}
																			<div class="label sign-in">
																				<div class="label__icon">
																					<svg width="16" height="19">
																						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																					</svg>
																				</div>
																				<span class="label__text">{{translations.SignInToSeePrice}}</span>
																			</div>
																			<div class="prices-container__suggested">
																				{% if supplyProduct.PreviousPrice != null -%}
																					<span class="value">{{ supplyProduct.TotalPreviousPrice }} {{ currencyExt }}</span> {{ translations.Brutto | Downcase }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																				{% endif -%}
																			</div>
																		{% else -%}
																			<button aria-label="ask-for-price" style="gap:8px;" class="pure-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
																				{{ translations.AskForPrice }}
																				<svg width="20" height="20" class="primary-action-button__icon">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																				</svg>
																			</button>
																		{% endif -%}
																	</td>
																{% endunless -%}
															{% else -%}
																{% if customer.Cart.SubtotalPrices -%}
																	<td class="netto-price-column" data-netto-price="{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio }}">
																		{% if supplyProduct.Price != null -%}
																			{% if customer.HidePrices == false -%}
																				<span class="netto-price-column__price">
																					<span class="netto-js">
																						{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																					</span>
																					<span class="price">{{ currencyExt }}</span>
																					{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																							<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																						{% else -%}
																							<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																								<span class="netto-previous-js">{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																							</div>
																						{% endif -%}
																					{% endif -%}
																				</span>
																				{% if supplyProduct.DepositValue > 0 -%}
																					<span class="netto-price-column__deposit-price">
																						<span>+ {{translations.Com_Deposit}}: </span>
																						<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																							{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																						</span>
																					</span>
																				{% endif -%}
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] and customer.HidePrices == false %}
																				{% for unit in supplyProduct.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != supplyUnitId -%}
																							<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != supplyProduct.BasicUnit -%}
																							<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price and settings.lowestProductPrice == 'yes' -%}
																				<div class="netto-price-column__lowest-price netto-lowest-js">{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																			{% endif -%}
																		{% elseif customer.HidePrices -%}
																			{% if settings.signIn == "page" -%}
																				<a class="netto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																			{% else -%}
																				<a class="netto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																			{% endif -%}
																			<div class="netto-price-column__tooltip">
																				<svg class="icon">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																				</svg>
																				<div class="text">
																					<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																				</div>
																			</div>
																		{% else -%}
																			<button aria-label="ask-for-price" style="gap:8px;" class="pure-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
																				{{ translations.AskForPrice }}
																				<svg width="20" height="20" class="primary-action-button__icon">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
																				</svg>
																			</button>
																		{% endif -%}
																	</td>
																{% else -%}
																	<td class="brutto-price-column" data-brutto-price="{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio }}">
																		{% if supplyProduct.Price != null -%}
																			{% if customer.HidePrices == false -%}
																				<span class="brutto-price-column__price">
																					<span class="brutto-js">
																						{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																					</span>
																					<span class="price">{{ currencyExt }}</span>
																					{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																							<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																						{% else -%}
																							<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio }}" {% endif -%}>
																								<span class="brutto-previous-js">{{ supplyProduct.PreviousPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																							</div>
																						{% endif -%}
																					{% endif -%}
																				</span>
																				{% if supplyProduct.DepositValue > 0 -%}
																					<span class="brutto-price-column__deposit-price">
																						<span>+ {{translations.Com_Deposit}}: </span>
																						<span class="deposit-js" data-deposit-price="{{ supplyProduct.DepositValue | Times: supplyProduct.BasicUnitRatio }}">
																							{{ supplyProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ supplyProduct.BasicUnit }}
																						</span>
																					</span>
																				{% endif -%}
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and supplyProduct.Units[1] and customer.HidePrices == false %}
																				{% for unit in supplyProduct.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != supplyUnitId -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyUnitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != supplyProduct.BasicUnit -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ supplyProduct.Price | DividedBy: supplyProduct.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{supplyProduct.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% if supplyProduct.PreviousPrice != null and supplyProduct.PreviousPrice > supplyProduct.Price and settings.lowestProductPrice == 'yes' -%}
																				<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ supplyProduct.MinPrice | DividedBy: supplyProduct.BasicUnitRatio | Times: supplyUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																			{% endif -%}
																		{% elseif customer.HidePrices -%}
																			{% if settings.signIn == "page" -%}
																				<a class="brutto-price-column__sign-in-on-child" href="{{ page.BaseHref }}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>
																			{% else -%}
																				<a class="brutto-price-column__sign-in-on-child show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>
																			{% endif -%}
																			<div class="brutto-price-column__tooltip">
																				<svg class="icon">
																					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
																				</svg>
																				<div class="text">
																					<p>{{ translations.PricesAvalibleForSignedIn }}. {% if settings.signIn == "page" -%}<a href="{{page.BaseHref}}{{config.DefinedPages.Login.Url}}" rel="nofollow">{{ translations.SignIn }}</a>{% else -%}<a class="show-login-popup-js" rel="nofollow">{{ translations.SignIn }}</a>{% endif -%}, {{ translations.ToSeePrices | Downcase }}.</p>
																				</div>
																			</div>
																		{% else -%}
																			{{ translations.AskForPrice }}
																		{% endif -%}
																	</td>
																{% endif -%}
															{% endif -%}
															{% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%}
																<td class="notify-about-availability-column" colspan="1">
																	{% if customer.HidePrices == false -%}
																		<button aria-label="notify-about-availability" class="pure-button notify-about-availability-column__button load-product-presentation-form-js opening-modal-mobile-js no-supply-product-on-controlled-stock-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}?supplyId={{ product.Id }}" data-include="notify-about-availability">
																			{{ translations.NotifyAboutAvailability }}
																		</button>
																	{% endif -%}
																</td>
																{% if config.Stock.Enabled -%}
																	<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl and showStock -%} data-stock-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{supplyProduct.Id}}"></td>
																{% endif -%}
															{% else -%}
																{% if supplyStockLevel != null and showStock -%}
																	<td class="stock-column" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl == false and showStock -%} data-stock-not-max-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%}>
																		<div class="stock-column-data">
																			{% if supplyStockLevel.ImageUrl != null -%}
																				{% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 2 -%}
																					<img alt="{{ supplyStockLevel.Text }}" {% if supplyStockLevel.Text != null -%} {% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 3 -%} title="{{ supplyStockLevel.Text }}" {% endif -%} {% endif -%} src="css/img/alo.gif" data-src="{{ supplyStockLevel.ImageUrl }}">
																				{% endif -%}
																			{% endif -%}
																			<div class="stock">
																				{{translations.InStock}}: {% if supplyStockLevel.Type == 1 or supplyStockLevel.Type == 3 -%}{{ supplyStockLevel.Text }}{% elseif supplyStockLevel.Type == 4 -%}<span class="max-js">{{ supplyStockLevel.Value | Normalize }}</span>{% endif %}
																			</div>
																		</div>
																	</td>
																{% endif -%}
																<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if supplyStockLevel != null and supplyStockLevel.QuantityControl and showStock -%} data-stock-value="{{ supplyStockLevel.Value | Normalize }}" data-basic-unit="{{ supplyProduct.BasicUnitRatio }}" {% endif -%} data-supply-id="{{supplyProduct.Id}}">
																	{% if noSupplyProductOnControlledStock == false and supplyProduct.AskForPrice == false and supplyProduct.Availability.Status != 3 -%}
																		{% if product.Clip -%}
																			{% include 'partials/product/amount-stepper.html' with supplyProduct -%}
																		{% elseif product.Batch -%}
																			{% include 'partials/product/amount-stepper.html' with supplyStockLevel -%}
																		{% endif -%}
																	{% endif -%}
																</td>
																{% assign unitRatioInfo = false -%}
																{% if settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and supplyUnitName != supplyProduct.BasicUnit -%}
																	{% assign unitRatioInfo = true -%}
																{% endif -%}
															{% endif -%}
															<td class="unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{supplyProduct.BasicUnitRatio}}">
																{% if supplyProduct.Units[1] -%}
																	<div tabindex="0" class="unit-column__units select select-js child-select-js">
																		<select id="unit-select-{{ supplyProduct.Id }}-{{ forloop.index0 }}" class="memory-js" data-index="{{ forloop.index0 }}" aria-label="{{ translations.Unit }}">
																			{% for unit in supplyProduct.Units -%}
																				{% if unit.Id == unitId -%}
																					{% assign defaultUnitName = unit.Name -%}
																				{% endif -%}
																				<option value="{{ unit.Id }}" {% if unit.Id == supplyUnitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																			{% endfor -%}
																		</select>
																		<div class="select__input">
																			<span class="selected-js">
																				{{ defaultUnitName | H }}
																			</span>
																			<svg>
																				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																			</svg>
																		</div>
																		<ul class="select__options options-js units-in-table-js">
																			{% for unit in supplyProduct.Units -%}
																				<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																			{% endfor -%}
																		</ul>
																		<input id="unit-dimensions-{{ supplyProduct.Id }}-{{ forloop.index0 }}" class="dimensions-js" type="hidden"
																		{% for unit in supplyProduct.Units -%}
																			{% assign dimensionsByUnitIndex = unit.Dimensions  -%}
																			data-unit{{unit.Id}}="{{dimensionsByUnitIndex.Height}}|{{dimensionsByUnitIndex.Length}}|{{dimensionsByUnitIndex.Width}}"
																		{% endfor -%}>
																	</div>
																	<div class="unit-column__unit-ratio-info">
																		{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																			{% assign productUnitsSize = supplyProduct.Units | Size -%}
																			{% for unit in supplyProduct.Units -%}
																				{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																					{% if unit.Id != supplyUnitId -%}
																						<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: supplyUnitRatio | Round: 4 }} {{ supplyUnitName }}</span>
																					{% endif -%}
																				{% else -%}
																					{% if unit.Name != supplyProduct.BasicUnit -%}
																						<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{unit.Ratio | Round: 4}} {{supplyProduct.BasicUnit}}</span>
																					{% endif -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endif -%}
																	</div>
																{% else -%}
																	{{ supplyUnitName }}
																{% endif -%}
																{% if supplyProduct.BasicUnitMinQuantity > 1 -%}
																	<div class="min-quantity-info phantom">
																		<svg>
																			<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																		</svg>
																		<span>
																			{{ translations.FillProperMinQuantity }} <strong>{{ supplyProduct.BasicUnitMinQuantity | Round }} {{ supplyProduct.BasicUnit }}</strong>
																		</span>
																	</div>
																{% endif -%}
															</td>
															{% if supply.ValueId == key -%}
																{% assign supplies = supply.Supplies -%}
															{% endif -%}
															<input name="supplyId" type="hidden" value="{{ supply.SupplyId }}" data-supply="{{ supply.SupplyId }}">
															{% assign dataKeys = dataKeys | Split:',' -%}
															{% for keyVal in dataKeys -%}
																<input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
															{% endfor -%}
														</tr>
														{% if noSupplyProductOnControlledStock == false and supplyProduct.Availability.Status != 3 -%}
															{% if supplyProduct.AttributesEditable[0] or supplyProduct.AttributesPolyvalent[0] -%}
																<tr class="attr-container-row {% if noSupplyProductOnControlledStock or supplyProduct.Availability.Status == 3 -%} unavailable {% endif -%} {% if supplyProduct.AskForPrice -%} ask-for-price-child-js {% endif -%}" data-url="{{ url }}?keys={{ dataKeys }}{% if unitId != null -%}&unit={{ unitId }}{% endif -%}" data-child-index="{{ forloop.index0 }}" data-supply-id="{{ supply.SupplyId }}" data-img="http:{{ page.BaseHref }}img/large/{{ supplyProduct.ImageId }}/.jpg" data-code="{{ supplyProduct.Code | H }}" data-weight="{{ supplyProduct.Weight }}" data-netweight="{{ supplyProduct.NetWeight}}">
																	<td colspan="100%">
																		<div class="last-level-attribute__more-attributes expandable-js">
																			<div class="attr-container">
																				{% if supplyProduct.AttributesEditable[0] -%}
																					{% for attrEditable in supplyProduct.AttributesEditable -%}
																						<div class="attribute-editable attribute-container-js">
																							<input name="attributePolyvalent" type="hidden" value="{{ attrEditable.Id }}">
																							<div class="form__input-wrapper">
																								{% case attrEditable.Format -%}
																									{% when 1 -%}
																										<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																										<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																										<div class="form__input-value--clear-button">
																											<svg>
																												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																											</svg>
																										</div>	
																									{% when 2 -%}
																										<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																										<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
																									{% when 3 -%}
																										<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																										<div tabindex="0" class="select select-js">
																											<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																												{% for val in attrEditable.Values %}
																													<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																												{% endfor -%}
																											</select>
																											<div class="select__input">
																												<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																													{{ attrEditable.Values[0].Value }}
																												</span>
																												<svg>
																													<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																												</svg>
																											</div>
																											<ul class="select__options options-js">
																												{% for val in attrEditable.Values %}
																													<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																												{% endfor -%}
																											</ul>
																										</div>
																									{% when 4 -%}
																										<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																										<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
																								{% endcase -%}
																								<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																									{{ translations.FillAttributeValue }}
																								</div>
																							</div>
																						</div>
																					{% endfor -%}
																				{% endif -%}
																				{% if supplyProduct.AttributesPolyvalent[0] -%}
																					{% for attrPolyvalent in supplyProduct.AttributesPolyvalent -%}
																						<div class="attribute-editable attribute-container-js">
																							<div class="form__input-wrapper">
																								<span class="form__input-info input-info-js on-label">{{ attrPolyvalent.Name }}</span>
																								<div tabindex="0" class="select select-js">
																									<select aria-label="{{ attrPolyvalent.Name }}" class="memory-js" name="attributePolyvalent">
																										{% for val in attrPolyvalent.Values %}
																											<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																										{% endfor -%}
																									</select>
																									<div class="select__input">
																										<span class="selected-js" title="{{ attrPolyvalent.Values[0].Value }}">
																											{{ attrPolyvalent.Values[0].Value }}
																										</span>
																										<svg>
																											<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																										</svg>
																									</div>
																									<ul class="select__options options-js">
																										{% for val in attrPolyvalent.Values %}
																											<li tabindex="-1" data-name="attributePolyvalent" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																										{% endfor -%}
																									</ul>
																								</div>
																								<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																									{{ translations.FillAttributeValue }}
																								</div>
																							</div>
																						</div>
																					{% endfor -%}
																				{% endif -%}
																			</div>
																		</div>
																	</td>
																</tr>
															{% endif -%}
														{% endif -%}
													{% endfor -%}
												</tbody>
											</table>
										</div>
									{% endif -%}
								{% endfor -%}
							{% endif -%}
						{% endif -%}
					{% endif -%}

					{% unless product.Clip or product.Batch -%}
						{% if activeProduct.Availability.Status == 3 -%}
							{% assign notifyMe = true -%}
						{% else -%}
							{% assign notifyMe = false -%}
						{% endif -%}

						{% if graphicalVariants == true -%}
							{% if activeProduct.AttributesPolyvalent[0] and activeProduct.AskForPrice == false and activeProduct.Archival == false and notifyMe == false -%}
								{% if settings.productIsInCart == 'productIsInCart-yes' -%}
									<input type="hidden" class="isInCartId" value="{{activeProduct.Id}}">
								{% endif -%}

								<div class="attributes-container-js">
									{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}			
									{% comment -%} <!-- First level with color or value (no thumbnail - same image) --> {% endcomment -%}
									{% assign firstLevelAttributePolyvalent = activeProduct.AttributesPolyvalent[0] -%}
									{% assign lvl = 1 -%}
									{% assign selectedAttributeId = attributeIds[0] -%}
									{% comment -%} <!-- Name and value of active variant --> {% endcomment -%}

									{% for value in firstLevelAttributePolyvalent.Values -%}
										{% if value.ValueId == selectedAttributeId -%}
											{% assign activeAttributeValue = value.Value -%}
											{% break -%}
										{% endif -%}
									{% endfor -%}
									<div class="attributes__container">
										{% assign attribute = firstLevelAttributePolyvalent -%}
										{% assign variantsSize = attribute.Values | Size -%}
										{% assign firstLevelName = attribute.Name -%}
										{% assign firstLevelValue = activeAttributeValue -%}
										
										<p class="name">{{firstLevelName}}: <span class="value graphical-variant-name-js">{{firstLevelValue}}</span></p>
										<div class="graphical-variants graphical-variants-js values attr-poly-table-js attr-graphical-variants-js">
											{% for value in attribute.Values -%}
												<div class="graphical-variant graphical-variant-js {% if forloop.index > graphicalVariantsLimit -%} hidden-js {% endif -%} {% if value.ValueId == selectedAttributeId -%} active-js {% endif -%} {% if levelsQuantity == 1 %} last-level-attribute child-js with-attributes {% endif %}" {% if levelsQuantity == 1 -%} data-child-index="{{ forloop.index0 }}" data-weight="{{ activeProduct.Weight }}" data-netweight="{{ activeProduct.NetWeight }}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}"{% endif -%}>
													{% if settings.grapicalVariantsPresentation == 'Variants_Colors' -%}
														{% assign anyColor = false -%}
														{% for value in attribute.Values -%}
															{% for color in colorVariants -%}
																{% assign colorArr = color | Split: '||' -%}

																{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
																{% assign valueDowncase = value.Value | Downcase -%}
																{% assign colorDowncase = colorArr[0] | Downcase -%}
																
																{% if colorDowncase == valueDowncase -%}
																	{% assign anyColor = true -%}
																	{% break -%}
																{% endif -%}
															{% endfor -%}
														{% endfor -%}

														{% assign colorHex = '#FFFFFF' -%}
														{% for color in colorVariants %}
															{% assign colorArr = color | Split: '||' -%}

															{%comment %} <!-- Case-insensitive comparison --> {% endcomment -%}
															{% assign valueDowncase = value.Value | Downcase -%}
															{% assign colorDowncase = colorArr[0] | Downcase -%}

															{% if colorDowncase == valueDowncase -%}
																{% assign colorHex = colorArr[1] -%}
																{% break -%}
															{% endif -%}
														{% endfor -%}

														{% comment %} <!-- Color representation --> {% endcomment %}
														<label tabindex="0" class="chip {% if anyColor -%} chip--color {% else -%} chip--default {% endif -%}">
															<input tabindex="-1" type="radio" name="attributeId" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
															{% if anyColor -%}
																<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
																	{% if colorHex == 'multicolor' %}
																		<foreignObject x="4" y="4" width="32" height="32">
																			<div xmlns="http://www.w3.org/1999/xhtml" class="multicolor"></div>
																		</foreignObject>
																	{% else %}
																		<circle cx="20" cy="20" r="16" fill="{{ colorHex }}" {% if colorHex == '#FFFFFF' %} stroke="black" stroke-width="0.25"{% endif %}/>
																	{% endif %}
																</svg>
															{% else -%}
																{{value.Value}}
															{% endif -%}
														</label>
													{% else -%}
														{% comment %} <!-- Normal chip --> {% endcomment %}
														<label tabindex="0" class="chip chip--default">
															<input tabindex="-1" type="radio" name="attributeId" value="{{ value.ValueId }}" {% if value.ValueId == selectedAttributeId -%} checked {% endif -%} data-variant="{{ value.Value }}">
															{{value.Value}}
														</label>
													{% endif -%}
												</div>
											{% endfor -%}
											
											{% assign showMoreCount = variantsSize | Minus: graphicalVariantsLimit -%}
											{% if showMoreCount > 0 -%}
												<button class="open-variants-popup-js pure-button chip chip--showMore">{{translations.More}} +{{ showMoreCount }}
												</button>
											{% endif -%}

											{% if variantsSize > graphicalVariantsLimit -%}
												{% include 'partials/product/graphical-variant-popup.html' with 'polyvalent' -%}
											{% endif -%}
										</div>
									</div>

									{% comment -%} <!-- Other levels --> {% endcomment -%}
									{% assign otherLevels = activeProduct.AttributesPolyvalent | Skip: 1 -%}
									{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}

									{% for attribute in otherLevels -%}
										{% assign lvl = forloop.index | Plus: 1 -%}
										<div class="attributes__container attributes-js {% if lvl == levelsQuantity -%} attr-poly-table-js attr-graphical-variants-js {% endif -%}">
											{% comment -%}<!-- Level values-->{% endcomment -%}
											<p class="name">{{attribute.Name}}</p>
											<div class="values">
												{% for value in attribute.Values -%}
													{% comment -%} <!-- Find the selected attribute id for the current level --> {% endcomment -%}
													{% for attributeId in attributeIds -%}
														{% if attributeId == value.ValueId -%}
															{% assign activeAttributeId = attributeId -%}
															{% break -%}
														{% endif -%}
													{% endfor -%}									

													<button class="value {% if value.ValueId == activeAttributeId -%} active-js {% endif -%} {% if lvl == levelsQuantity -%} last-level-attribute child-js with-attributes{% endif -%}" {% if lvl == levelsQuantity -%} data-child-index="{{ forloop.index0 }}" data-weight="{{ activeProduct.Weight }}" data-netweight="{{ activeProduct.NetWeight }}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}"{% endif -%} data-many-attributes-id="{{ value.ValueId }}">
														{{ value.Value }}
														<input name="attributeId" type="hidden" value="{{value.ValueId}}">
													</button>
												{% endfor -%}
											</div>
										</div>
									{% endfor -%}
								</div>

								{% comment -%} <!-- Attributes editable --> {% endcomment -%}
								{% if activeProduct.AttributesEditable[0] -%}
									<div class="last-level-attribute attributes-container-js">
										<div class="last-level-attribute__more-attributes">
											{% for attrEditable in activeProduct.AttributesEditable -%}
												<div class="attribute-editable attribute-container-js">
													<input name="attributeId" type="hidden" value="{{ attrEditable.Id }}">
													<div class="form__input-wrapper">
														{% case attrEditable.Format -%}
															{% when 1 -%}
																<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																<div class="form__input-value--clear-button">
																	<svg>
																		<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																	</svg>
																</div>	
															{% when 2 -%}
																<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
															{% when 3 -%}
																<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																<div tabindex="0" class="select select-js">
																	<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																		{% for val in attrEditable.Values %}
																			<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																		{% endfor -%}
																	</select>
																	<div class="select__input">
																		<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																			{{ attrEditable.Values[0].Value }}
																		</span>
																		<svg>
																			<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																		</svg>
																	</div>
																	<ul class="select__options options-js">
																		{% for val in attrEditable.Values %}
																			<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																		{% endfor -%}
																	</ul>
																</div>
															{% when 4 -%}
																<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
														{% endcase -%}
														<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
															{{ translations.FillAttributeValue }}
														</div>
													</div>
												</div>
											{% endfor -%}
										</div>
									</div>
								{% endif -%}

								{% comment -%} <!-- Quantity and Unit --> {% endcomment -%}
								<div class="graphical-variants__quantity-unit">
									<div class="graphical-variants__quantity quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ activeProduct.BasicUnitRatio }}" {% endif -%}>
										{% include 'partials/product/amount-stepper.html' with activeProduct -%}
									</div>

									{% assign unitRatioInfo = false -%}
									{% if activeProduct.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != activeProduct.BasicUnit -%}
										{% assign unitRatioInfo = true -%}
									{% endif -%}

									<div class="graphical-variants__unit unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
										{% if activeProduct.Units[1] -%}
											<div tabindex="0" class="unit-column__units select select-js child-select-js">
												<select id="unit-select-{{ activeProduct.Id }}" class="memory-js" data-index="0" aria-label="{{ translations.Unit }}">
													{% for unit in activeProduct.Units -%}
														{% if unit.Id == unitId -%}
															{% assign defaultUnitName = unit.Name -%}
														{% endif -%}
														<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
													{% endfor -%}
												</select>
												<div class="select__input">
													<span class="selected-js">
														{{ defaultUnitName | H }}
													</span>
													<svg>
														<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
													</svg>
												</div>

												<ul class="select__options options-js units-in-table-js">
													{% for unit in product.Units -%}
														<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
													{% endfor -%}
												</ul>
											</div>
											
											<div class="unit-column__unit-ratio-info">
												{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
													{% assign productUnitsSize = product.Units | Size -%}
													{% for unit in product.Units -%}
														{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
															{% if unit.Id != unitId -%}
																<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
															{% endif -%}
														{% else -%}
															{% if unit.Name != activeProduct.BasicUnit -%}
																<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
															{% endif -%}
														{% endif -%}
													{% endfor -%}
												{% endif -%}
											</div>
										{% else -%}
											{{ activeProduct.SaleUnit }}
										{% endif -%}
										{% if activeProduct.BasicUnitMinQuantity > 1 -%}
											<div class="min-quantity-info phantom">
												<svg>
													<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
												</svg>
												<span>
													{{ translations.FillProperMinQuantity }} <strong>{{ activeProduct.BasicUnitMinQuantity | Round }} {{ activeProduct.BasicUnit }}</strong>
												</span>
											</div>
										{% endif -%}
									</div>
								</div>
							{% endif -%}
						{% else -%}
							{% if activeProduct.Availability.Status == 3 -%}
								{% assign notifyMe = true -%}
							{% else -%}
								{% assign notifyMe = false -%}
							{% endif -%}
							{% if activeProduct.AttributesPolyvalent[0] and product.AskForPrice == false and product.Archival == false and notifyMe == false -%}
								{% if settings.productIsInCart == 'productIsInCart-yes' -%}
									<input type="hidden" class="isInCartId" value="{{activeProduct.Id}}">
								{% endif -%}
								{% for attribute in activeProduct.AttributesPolyvalent -%}
									<div class="attributes-js">
										{% assign lvl = forloop.index -%}
										{% assign levelsQuantity = activeProduct.AttributesPolyvalent | Size -%}
										{% if lvl != levelsQuantity -%}
											<div class="attributes__not-last-level-attribute">
												<input name="attributeId" type="hidden" value="{{ attribute.Values[0].ValueId }}">
												<div class="name">{{ attribute.Name }}</div>
												<div class="values">
													{% for value in attribute.Values -%}
														<button aria-label="attribute-button" class="value {% if value.ValueId == attribute.Values[0].ValueId -%} active-js {% endif -%}" data-many-attributes-id="{{ value.ValueId }}">
															{{ value.Value }}
														</button>
													{% endfor -%}
												</div>
											</div>
										{% else -%}
											<div class="attributes__table-container attr-poly-table-js">
												<table>
													<colgroup>
														<col style="width: 100px;">
														<col style="width: 150px;">
														{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<col style="width: 150px;">{% endunless -%}
														<col style="width: 250px;">
													</colgroup>
													<thead>
														<tr>
															<th class="name-column attribute-name-js">{{ attribute.Name }}</th>
															{% if config.ENTERPRISE -%}
																<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<th class="brutto-price-column">{{ translations.TotalPrice }}</th>{% endunless -%}
															{% else -%}
																{% if customer.Cart.SubtotalPrices -%}
																	<th class="netto-price-column">{{ translations.SubtotalPrice }}</th>
																{% else -%}
																	<th class="brutto-price-column">{{ translations.TotalPrice }}</th>
																{% endif -%}
															{% endif -%}
															{% if product.StockLevel != null and showStock -%}
																<th class="stock-column">{{ translations.Stock }}</th>
															{% endif -%}
															<th class="quantity-column">{{ translations.Quantity }}</th>
															<th class="unit-column">{{ translations.Unit }}</th>
														</tr>
													</thead>
													<tbody>
														{% if config.ENTERPRISE -%}
															{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																	{% assign unitRatioInfoExists = true -%}
																{% endif -%}
															{% endunless -%}
															{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																{% assign previousPriceExists = true -%}
															{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice -%}
																{% assign previousPriceExists = true -%}
															{% endif -%}
														{% else -%}
															{% if customer.Cart.SubtotalPrices -%}
																{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																	{% assign unitRatioInfoExists = true -%}
																{% endif -%}
																{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																	{% assign previousPriceExists = true -%}
																{% endif -%}
															{% else -%}
																	{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] -%}
																		{% assign unitRatioInfoExists = true -%}
																	{% endif -%}
																	{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																		{% assign previousPriceExists = true -%}
																	{% endif -%}
															{% endif -%}
														{% endif -%}
														{% for value in attribute.Values -%}
															<tr tabindex="0" class="last-level-attribute child-js with-attributes" data-child-index="{{ forloop.index0 }}" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}" data-img="http:{{ page.BaseHref }}img/large/{{ activeProduct.ImageId }}/.jpg" data-code="{{ activeProduct.Code }}">
																<td class="name-column">{{ value.Value }}</td>
																{% assign activeProductUnitsSize = activeProduct.Units | Size -%}
																{% if settings.thresholds == 'yes' and activeProduct.HasThresholds and activeProduct.Price != null and activeProductUnitsSize == 1 -%}
																	<td class="thresholds-column" {% if config.ENTERPRISE -%} colspan="2" {% endif -%}>
																		{% assign whatPrice = translations.Brutto | Downcase -%}
																		{% if customer.Cart.SubtotalPrices -%}
																			{% assign whatPrice = translations.Netto | Downcase -%}
																		{% endif -%}
																		{% assign firstThreshold = activeProduct.Thresholds | First -%}
																		{% assign lastThreshold = activeProduct.Thresholds | Last -%}
																		<div class="thresholds-column__label">{{ translations.Price }} {{ whatPrice }}</div>
																		<div class="">
																			{{ translations.RangeFrom | Downcase }} <strong>{{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong> {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
																		</div>
																		{% assign thresholdsSize = activeProduct.Thresholds | Size -%}
																		{% if thresholdsSize >= 2 -%}
																			<button class="thresholds-column__open-thresholds-popup pure-button open-next-element-js stop-propagation-js">{{ translations.SeePriceDetails }}</button>
																			<div class="popup-background hidden-js hide-js container-to-hide-js">
																				<div class="popup thresholds-popup">
																					<div class="popup__header">
																						<div class="title">{{ translations.PriceDetails }}</div>
																						<svg class="hide-container-js">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																						</svg>
																					</div>
																					<div class="popup__content">
																						<div class="name">{{ activeProduct.Name }}</div>
																						<div class="thresholds">
																							<div class="thresholds__row">
																								<span>{{ translations.Quantity }} [{{ {{ product.SaleUnit }} }}]:</span>
																								<span>{{ translations.Price }} {{ whatPrice }}:</span>
																							</div>
																							{% for threshold in activeProduct.Thresholds -%}
																								<div class="thresholds__row">
																									<div>{{ threshold.Threshold | Normalize }}+</div>
																									<div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
																								</div>
																							{% endfor %}
																						</div>
																					</div>
																				</div>
																			</div>
																		{% endif -%}
																	</td>
																{% elseif config.ENTERPRISE -%}
																	<td class="netto-price-column" data-netto-price="{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio }}">
																		{% if customer.HidePrices == false -%}
																			<span class="netto-price-column__price">
																				<span class="netto-js">
																					{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																				</span>
																				<span class="price">{{ currencyExt }}</span>
																				{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																						<div class="netto-price-column__lowest-price netto-previous-js" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																					{% else -%}
																						<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																							<span class="netto-previous-js">{{ activeProduct.SubtotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																						</div>
																					{% endif -%}
																				{% elseif activeProduct.SubtotalRegularPrice != null and activeProduct.SubtotalRegularPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'no' -%}
																					<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																					<div class="netto-price-column__previous-price" data-nettoprevious-price="{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																						<span class="netto-previous-js">{{ activeProduct.SubtotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																					</div>
																				{% endif -%}
																			</span>
																			{% if activeProduct.DepositValue > 0 -%}
																				<span class="netto-price-column__deposit-price">
																					<span>+ {{translations.Com_Deposit}}: </span>
																					<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																						{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.SaleUnit }}
																					</span>
																				</span>
																			{% endif -%}
																		{% endif -%}
																		{% if customer.HidePrices == true -%}
																			<div class="label sign-in">
																				<div class="label__icon">
																					<svg width="16" height="19">
																						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																					</svg>
																				</div>
																				<span class="label__text">{{translations.SignInToSeePrice}}</span>
																			</div>
																			<div class="prices-container__suggested">
																				{% if activeProduct.SubtotalPreviousPrice != null and customer.HidePrices -%}
																					<span class="value">{{ activeProduct.SubtotalPreviousPrice }} {{ currencyExt }}</span> {{ translations.Netto | Downcase }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																				{% endif -%}
																			</div>
																		{% endif -%}
																		{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] and customer.HidePrices == false -%}
																			{% for unit in product.Units -%}
																				{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																					{% if unit.Id != unitId -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																						</div>
																					{% endif -%}
																				{% else -%}
																					{% if unit.Name != product.BasicUnit -%}
																						<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																							{{ activeProduct.SubtotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																						</div>
																					{% endif -%}
																				{% endif -%}
																			{% endfor -%}
																		{% endif -%}
																		{% if activeProduct.SubtotalPreviousPrice != null and activeProduct.SubtotalPreviousPrice > activeProduct.SubtotalPrice and settings.lowestProductPrice == 'yes' -%}
																			<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.SubtotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																		{% endif -%}
																	</td>
																	{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																		<td class="brutto-price-column" data-brutto-price="{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio }}">
																			{% if customer.HidePrices == false -%}
																				<span class="brutto-price-column__price">
																					<span class="brutto-js">
																						{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																					</span>
																					<span class="price">{{ currencyExt }}</span>
																					{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																							<div class="brutto-price-column__lowest-price {% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}brutto-previous-js{% endunless -%}" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}{% endunless -%}</div>
																						{% else -%}
																							<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																								{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}<span class="brutto-previous-js">{{ activeProduct.TotalPreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>{% endunless -%}
																							</div>
																						{% endif -%}
																					{% elseif activeProduct.TotalRegularPrice != null and activeProduct.TotalRegularPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'no' -%}
																						<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																						<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio }}">
																							<span class="brutto-previous-js">{{ activeProduct.TotalRegularPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} </span>
																						</div>
																					{% endif -%}
																				</span>
																				{% if activeProduct.DepositValue > 0 -%}
																					<span class="brutto-price-column__deposit-price">
																						<span>+ {{translations.Com_Deposit}}: </span>
																						<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																							{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																						</span>
																					</span>
																				{% endif -%}
																			{% endif -%}
																			{% if customer.HidePrices == true %}
																				<div class="label sign-in">
																					<div class="label__icon">
																						<svg width="16" height="19">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																						</svg>
																					</div>
																					<span class="label__text">{{translations.SignInToSeePrice}}</span>
																				</div>
																				<div class="prices-container__suggested">
																					{% if activeProduct.PreviousPrice != null and customer.HidePrices -%}
																						<span class="value">{{ activeProduct.TotalPreviousPrice }} {{ currencyExt }}</span> {{ translations.Brutto | Downcase }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																					{% endif -%}
																				</div>
																			{% endif -%}
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] and customer.HidePrices == false -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																							</div>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != product.BasicUnit -%}
																							<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																								{{ activeProduct.TotalPrice | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																							</div>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																			{% unless customer.Cart.SubtotalPrices and settings.onlySubtotalPrice == 'yes' -%}
																				{% if activeProduct.TotalPreviousPrice != null and activeProduct.TotalPreviousPrice > activeProduct.TotalPrice and settings.lowestProductPrice == 'yes' -%}
																					<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.TotalMinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																				{% endif -%}
																			{% endunless -%}
																		</td>
																	{% endunless -%}
																{% else -%}
																	{% if customer.HidePrices == true %}
																		{% if customer.Cart.SubtotalPrices -%}
																			<td>
																				<div class="label sign-in">
																					<div class="label__icon">
																						<svg width="16" height="19">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																						</svg>
																					</div>
																					<span class="label__text">{{translations.SignInToSeePrice}}</span>
																				</div>
																				<div class="prices-container__suggested">
																				{% if product.PreviousPrice != null and customer.HidePrices -%}
																					<span class="value">{{ product.SubtotalPreviousPrice }} {{ currencyExt }}</span> {{ translations.Netto | Downcase }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																				{% endif -%}
																				</div>
																			</td>
																		{% else -%}
																			<td>
																				<div class="label sign-in">
																					<div class="label__icon">
																						<svg width="16" height="19">
																							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
																						</svg>
																					</div>
																					<span class="label__text">{{translations.SignInToSeePrice}}</span>
																				</div>
																				<div class="prices-container__suggested">
																				{% if product.PreviousPrice != null and customer.HidePrices -%}
																					<span class="value">{{ product.TotalPreviousPrice }} {{ currencyExt }}</span> {{ translations.Brutto | Downcase }} - {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%} {{translations.SuggestedRetailPrice}} {% else -%} {{translations.PreviousPrice}} {% endif-%}
																				{% endif -%}
																				</div>
																			</td>
																		{% endif -%}
																	{% else -%}
																		{% if customer.Cart.SubtotalPrices -%}
																			<td class="netto-price-column" data-netto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																				{% if customer.HidePrices == false -%}
																					<span class="netto-price-column__price">
																						<span class="netto-js">
																							{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																						</span>
																						<span class="price">{{ currencyExt }}</span>
																						{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
																								<div class="netto-price-column__lowest-price netto-previous-js"  data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																							{% else -%}
																								<div class="netto-price-column__previous-price"  data-nettoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-nettolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																									<span class="netto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																								</div>
																							{% endif -%}
																						{% endif -%}
																					</span>
																					{% if activeProduct.DepositValue > 0 -%}
																						<span class="netto-price-column__deposit-price">
																							<span>+ {{translations.Com_Deposit}}: </span>
																							<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																								{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																							</span>
																						</span>
																					{% endif -%}
																				{% endif -%}
																				{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] and customer.HidePrices == false -%}
																					{% for unit in product.Units -%}
																						{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																							{% if unit.Id != unitId -%}
																								<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																									{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																								</div>
																							{% endif -%}
																						{% else -%}
																							{% if unit.Name != product.BasicUnit -%}
																								<div class="netto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																									{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																								</div>
																							{% endif -%}
																						{% endif -%}
																					{% endfor -%}
																				{% endif -%}
																				{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																					<div class="netto-price-column__lowest-price netto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																				{% endif -%}
																			</td>
																		{% else -%}
																			<td class="brutto-price-column" data-brutto-price="{{ activeProduct.Price | DividedBy: product.BasicUnitRatio }}">
																				{% if customer.HidePrices == false -%}
																					<span class="brutto-price-column__price">
																						<span class="brutto-js">
																							{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }}
																						</span>
																						<span class="price">{{ currencyExt }}</span>
																						{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price -%}
																							<div class="hidden-js" data-currency="{{currencyExt}}"></div>
																							{% if settings.previousPriceAsSuggestedRetailPrice == 'yes' -%}
																								<div class="brutto-price-column__lowest-price brutto-previous-js" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.SuggestedRetailPrice}}</div>
																							{% else -%}
																								<div class="brutto-price-column__previous-price" data-bruttoprevious-price="{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio }}" {% if settings.lowestProductPrice == 'yes' -%} data-bruttolowest-price="{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio }}" {% endif -%}>
																									<span class="brutto-previous-js">{{ activeProduct.PreviousPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span>
																								</div>
																							{% endif -%}
																						{% endif -%}
																					</span>
																					{% if activeProduct.DepositValue > 0 -%}
																						<span class="brutto-price-column__deposit-price">
																							<span>+ {{translations.Com_Deposit}}: </span>
																							<span class="deposit-js" data-deposit-price="{{ activeProduct.DepositValue | DividedBy: product.BasicUnitRatio }}">
																								{{ activeProduct.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ activeProduct.BasicUnit }}
																							</span>
																						</span>
																					{% endif -%}
																				{% endif -%}
																				{% if settings.showUnitRateOnProductDetailsPage == 'yes' and product.Units[1] and customer.HidePrices == false -%}
																					{% for unit in product.Units -%}
																						{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																							{% if unit.Id != unitId -%}
																								<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																									{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{unitName}}
																								</div>
																							{% endif -%}
																						{% else -%}
																							{% if unit.Name != product.BasicUnit -%}
																								<div class="brutto-price-column__unit-ratio-info unit-ratio-info-js hidden-js" data-id="{{unit.Id}}">
																									{{ activeProduct.Price | DividedBy: product.BasicUnitRatio | Round: config.DecimalPlacesPrice | ToPrice: config.DecimalPlacesPrice }}/{{product.BasicUnit}}
																								</div>
																							{% endif -%}
																						{% endif -%}
																					{% endfor -%}
																				{% endif -%}
																				{% if activeProduct.PreviousPrice != null and activeProduct.PreviousPrice > activeProduct.Price and settings.lowestProductPrice == 'yes' -%}
																					<div class="brutto-price-column__lowest-price brutto-lowest-js">{{ activeProduct.MinPrice | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }} - {{translations.Price_Omnibus}}</div>
																				{% endif -%}
																			</td>
																		{% endif -%}
																	{% endif -%}
																{% endif -%}
																{% if activeProduct.StockLevel != null and showStock -%}
																	<td class="stock-column" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl == false and showStock -%} data-stock-not-max-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																		<div class="stock-column-data">
																			{% if activeProduct.StockLevel.ImageUrl != null -%}
																				{% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 2 -%}
																					<img alt="{{ activeProduct.StockLevel.Text }}" {% if activeProduct.StockLevel.Text != null -%} {% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 3 -%} title="{{ activeProduct.StockLevel.Text }}" {% endif -%} {% endif -%} src="css/img/alo.gif" data-src="{{ activeProduct.StockLevel.ImageUrl }}">
																				{% endif -%}
																			{% endif -%}
																			<div class="stock">
																				{% if activeProduct.StockLevel.Type == 1 or activeProduct.StockLevel.Type == 3 -%}{{ activeProduct.StockLevel.Text }}{% elseif activeProduct.StockLevel.Type == 4 -%}<span class="max-js">{{ activeProduct.StockLevel.Value | Normalize }}</span>{% endif %}
																			</div>
																		</div>
																	</td>
																{% endif -%}
																{% assign attributeIndex = forloop.index0 -%}
																<td class="quantity-column ammount-stepper-js" data-quantity="{% if config.Products.DecimalUnits -%}0{{ config.DecimalSeparator }}00{% else -%}0{% endif -%}" {% if activeProduct.StockLevel != null and activeProduct.StockLevel.QuantityControl and showStock -%} data-stock-value="{{ activeProduct.StockLevel.Value | Normalize }}" data-basic-unit="{{ product.BasicUnitRatio }}" {% endif -%}>
																	{% include 'partials/product/amount-stepper.html' with activeProduct -%}
																</td>
																{% assign unitRatioInfo = false -%}
																{% if product.Units[1] and settings.showUnitRateOnProductDetailsPage == 'yes' and settings.showUnitRateOnProductDetailsPageUnit == 'basic' and unitName != product.BasicUnit -%}
																	{% assign unitRatioInfo = true -%}
																{% endif -%}
																<td class="unit-column unit-ratio-js" data-unit="{{ unitId }}" data-unit-ratio-info="{{unitRatioInfo}}" data-basic-unit-ratio="{{product.BasicUnitRatio}}">
																	{% if product.Units[1] -%}
																		<div tabindex="0" class="unit-column__units select select-js child-select-js">
																			<select id="unit-select-{{ product.Id }}-{{ forloop.index0 }}" class="memory-js" data-index="{{ forloop.index0 }}" aria-label="{{ translations.Unit }}">
																				{% for unit in product.Units -%}
																					{% if unit.Id == unitId -%}
																						{% assign defaultUnitName = unit.Name -%}
																					{% endif -%}
																					<option value="{{ unit.Id }}" {% if unit.Id == unitId -%} selected {% endif -%}>{{ unit.Name | H }}</option>
																				{% endfor -%}
																			</select>
																			<div class="select__input">
																				<span class="selected-js">
																					{{ defaultUnitName | H }}
																				</span>
																				<svg>
																					<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																				</svg>
																			</div>
																			<ul class="select__options options-js units-in-table-js">
																				{% for unit in product.Units -%}
																					<li tabindex="-1" data-ratio="{{ unit.Ratio }}" data-value="{{ unit.Id }}" {% if unit.Multiplicity > 0 -%} data-multiplicity="{{ unit.Multiplicity }}" {% endif -%}>{{ unit.Name | H }}</li>
																				{% endfor -%}
																			</ul>
																		</div>
																		<div class="unit-column__unit-ratio-info">
																			{% if settings.showUnitRateOnProductDetailsPage == 'yes' -%}
																				{% assign productUnitsSize = product.Units | Size -%}
																				{% for unit in product.Units -%}
																					{% if settings.showUnitRateOnProductDetailsPageUnit == 'default' %}
																						{% if unit.Id != unitId -%}
																							<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | DividedBy: unitRatio | Round: 4 }} {{ unitName }}</span>
																						{% endif -%}
																					{% else -%}
																						{% if unit.Name != supplyProduct.BasicUnit -%}
																							<span class="unit-ratio-info-js {% if productUnitsSize > 1 -%} hidden-js {% endif -%}" data-id="{{unit.Id}}">{{ unit.Ratio | Round: 4 }} {{ product.BasicUnit }}</span>
																						{% endif -%}
																					{% endif -%}
																				{% endfor -%}
																			{% endif -%}
																		</div>
																	{% else -%}
																		{{ product.SaleUnit }}
																	{% endif -%}
																	{% if supplyProduct.BasicUnitMinQuantity > 1 -%}
																		<div class="min-quantity-info phantom">
																			<svg>
																				<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}'></use>
																			</svg>
																			<span>
																				{{ translations.FillProperMinQuantity }} <strong>{{ supplyProduct.BasicUnitMinQuantity | Round }} {{ supplyProduct.BasicUnit }}</strong>
																			</span>
																		</div>
																	{% endif -%}
																</td>
															</tr>
															{% if activeProduct.AttributesEditable[0] -%}
																<tr tabindex="0" class="last-level-attribute" data-child-index="{{ forloop.index0 }}" data-weight="{{ product.Weight }}" data-netweight="{{ product.NetWeight}}">
																	<td colspan="100%" class="last-level-attribute__more-attributes">
																		<input name="attributePolyvalent" type="hidden" value="{{ value.ValueId }}">
																		{% for attrEditable in activeProduct.AttributesEditable -%}
																			<div class="attribute-editable attribute-container-js">
																				<div class="form__input-wrapper">
																					{% case attrEditable.Format -%}
																						{% when 1 -%}
																							<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																							<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" >
																							<div class="form__input-value--clear-button">
																								<svg>
																									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
																								</svg>
																							</div>	
																						{% when 2 -%}
																							<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attrEditable.Name }}</label>
																							<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" >
																						{% when 3 -%}
																							<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																							<div tabindex="0" class="select select-js">
																								<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable">
																									{% for val in attrEditable.Values %}
																										<option value="{{ val.ValueId }}">{{ val.Value }}</option>
																									{% endfor -%}
																								</select>
																								<div class="select__input">
																									<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
																										{{ attrEditable.Values[0].Value }}
																									</span>
																									<svg>
																										<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
																									</svg>
																								</div>
																								<ul class="select__options options-js">
																									{% for val in attrEditable.Values %}
																										<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
																									{% endfor -%}
																								</ul>
																							</div>
																						{% when 4 -%}
																							<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js on-label">{{ attrEditable.Name }}</label>
																							<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" >
																					{% endcase -%}
																					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
																						{{ translations.FillAttributeValue }}
																					</div>
																				</div>
																				
																			</div>
																		{% endfor -%}
																	</td>
																</tr>
															{% else -%}
																<tr tabindex="0" class="hidden-js">
																	<td>
																		<input name="attributePolyvalent" type="hidden" value="{{ value.ValueId }}">
																	</td>
																</tr>
															{% endif -%}
														{% endfor -%}
													</tbody>
												</table>
											</div>
										{% endif -%}
									</div>
								{% endfor -%}
							{% endif -%}
						{% endif -%}

						{% if product.Batch == null or product.Batch == false -%}
							{% if activeProduct.AttributesEditable != empty and activeProduct.AttributesPolyvalent == empty -%}
								<p class="customize">{{ translations.Customize }}</p>
								{% for attribute in activeProduct.AttributesEditable -%}
									<div class="form__input-wrapper">
										<label for="attribute-edit-{{forloop.index}}" class="form__input-info input-info-js">{{ attribute.Name }} <span class="required">*</span></label>
										{% case attribute.Format -%}
											{% when 1 -%}
												<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="text" name="attributeEditable" value="" maxlength="50" required >
												<div class="form__input-value--clear-button">
													<svg>
														<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
													</svg>
												</div>											
											{% when 2 -%}
												<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="number" name="attributeEditable" value="" max="999999999999999" required >
											{% when 3 -%}
												<div tabindex="0" class="select select-js">
													<select id="attribute-edit-{{forloop.index}}" class="memory-js" name="attributeEditable" data-id="{{attribute.Id}}" aria-label="{{ attribute.Name }}">
														{% for val in attribute.Values %}
															<option {% if val.ValueId == attribute.Values[0].ValueId -%} selected {% endif -%} value="{{ val.ValueId }}">{{ val.Value }}</option>
														{% endfor -%}
													</select>
													<div class="select__input">
														<span class="selected-js" title="{{ attrEditable.Values[0].Value }}">
															{{ attrEditable.Values[0].Value }}
														</span>
														<svg width="16" height="16">
															<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
														</svg>
													</div>
													<ul class="select__options options-js">
														{% for val in attribute.Values %}
															<li tabindex="-1" data-value="{{ val.ValueId }}">{{ val.Value }}</li>
														{% endfor -%}
													</ul>
												</div>
											{% when 4 -%}
												<input id="attribute-edit-{{forloop.index}}" class="form__input-value input-value-js" type="date" name="attributeEditable" value="" required >
										{% endcase -%}
										<div class="form__invalid-input validation-info-js validation-required-js hidden-js">
											{{ translations.FillAttributeValue }}
										</div>
									</div>
								{% endfor -%}
							{% endif -%}
						{% endif -%}
					{% endunless -%}
				</div>

				<div class="buttons-container">
					<div class="buttons-container__buttons">
						{% assign noSimpleProductOnControlledStock = false -%}
						{% if noProductOnControlledStock and tableView == false -%}
							{% assign noSimpleProductOnControlledStock = true -%}
						{% else -%}
							{% assign noSimpleProductOnControlledStock = false -%}
						{% endif -%}

						{% assign noSimpleProductWithAttributesOnControlledStock = false -%}
						{% if noProductOnControlledStock and tableView and product.Clip == false and product.Batch == false -%}
							{% assign noSimpleProductWithAttributesOnControlledStock = true -%}
						{% else -%}
							{% assign noSimpleProductWithAttributesOnControlledStock = false -%}
						{% endif -%}

						{% if activeProduct.Availability.Status != 3 and noSimpleProductOnControlledStock == false and noSimpleProductWithAttributesOnControlledStock == false -%}
							{% unless joinedKeys == product.Supplies.Key and unitId == null -%}
								{% assign newQuery = true -%}
								{% capture dataUrl -%}{{ url }}?{% endcapture -%}
								{% if joinedKeys != product.Supplies.Key -%}
									{% capture dataUrl -%}{{ dataUrl }}keys={{ joinedKeys }}{% endcapture -%}
								{% endif -%}
								{% assign lastSign = dataUrl | Last -%}
								{% if unitId != null -%}
									{% if lastSign == '?' -%}
										{% capture dataUrl -%}{{ dataUrl }}unit={{ unitId }}{% endcapture -%}
									{% else -%}
										{% capture dataUrl -%}{{ dataUrl }}&unit={{ unitId }}{% endcapture -%}
									{% endif -%}
								{% endif -%}
							{% endunless -%}
							
							<div class="primary-buttons">
								{% if customer.HidePrices -%}
									<a aria-label="sign-in" {% if settings.signIn == "page" -%}href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}"{% else -%}class="show-login-popup-js"{% endif -%} rel="nofollow" title="{{ translations.SignIn }}">
										<div class="primary-action-button" style="min-height: auto;">
											<span class="primary-action-button__text">{{ translations.LogIn }}</span>
											<svg class="primary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
											</svg>
										</div>
									</a>
								{% elseif canBuy %}
									{% if settings.redirectCustomer == 'yes' and product.MoreInfoUrl != '' -%}
										<a class="primary-action-button" href="{{ product.MoreInfoUrl }}" target="_blank" rel="noopener noreferrer">
											<span class="primary-action-button__text">{{ translations.SeeMore }}</span>
										</a>
									{% elseif activeProduct.AskForPrice == false and noProductOnControlledStock == false -%}
										{% comment %} <!-- Add to cart button --> {% endcomment -%}
										<button aria-label="{{ translations.AddToCart }}" class="primary-action-button add-from-presentation-js add-to-cart-button-js parent-container-reload-js {% if tableView -%} add-many-products-js {% else -%} add-to-cart-update-client-area-js {% endif -%}" {% if newQuery and settings.afterAddingToCart != 1 -%}data-url="{{ dataUrl }}"{% endif -%} {% if customer.Carts[1] -%} data-current-cart-id="{{ currentCartId }}" {% endif -%}>
											<span class="primary-action-button__text">{{ translations.AddToCart }}</span>
											<svg class="primary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
											</svg>
											{% if settings.productIsInCart == 'productIsInCart-yes' -%}
												<svg class="svgIcon svgIcon-inCart isInCartIcon-js hidden-js">
													<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use>
												</svg>
											{% endif -%}
										</button>
										{% if settings.productIsInCart == 'productIsInCart-yes' -%}
											<div class="isInCartPopup isInCartPopup-js" style="display: none">
												{{translations.productIsInCart}}
											</div>
										{% endif -%}
										{% if customer.Authenticated -%}
											{% comment %} <!-- Add to wishlist button --> {% endcomment -%}
											<button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button wishlist {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
												<svg class="secondary-action-button__icon">
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
												</svg>
											</button>
										{% endif -%}
									{% elseif activeProduct.AskForPrice == true -%}
										{% comment %} <!-- Ask for price --> {% endcomment -%}
										<button aria-label="ask-for-price" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
											{{ translations.AskForPrice }}
											<svg class="primary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
											</svg>
										</button>
									{% elseif noProductOnControlledStock == true -%}
										{% comment %} <!-- Notify about availability --> {% endcomment -%}
										<button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}?supplyId={{ product.Id }}" data-include="notify-about-availability">
											<span>{{ translations.NotifyAboutAvailability }}</span>
											<svg width="18" height="20">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
											</svg>
										</button>
									{% endif -%}
								{% else %}
									{% if activeProduct.AskForPrice -%}
										{% comment %} <!-- Ask for price --> {% endcomment -%}
										<button aria-label="ask-for-price" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
											{{ translations.AskForPrice }}
											<svg class="primary-action-button__icon">
													<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
											</svg>
										</button>
									{% else -%}
										{% comment %} <!-- Notify about availability --> {% endcomment -%}
										<button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}?supplyId={{ product.Id }}" data-include="notify-about-availability">
											<span>{{ translations.NotifyAboutAvailability }}</span>
											<svg width="18" height="20">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
											</svg>
										</button>
									{% endif -%}
								{% endif -%}
							</div>
						{% endif -%}
						
						{% assign noSimpleProductOnControlledStock = false -%}
						{% if noProductOnControlledStock and tableView == false -%}
							{% assign noSimpleProductOnControlledStock = true -%}
						{% endif -%}
						{% if noProductOnControlledStock and tableView and product.Clip == false and product.Batch == false -%}
							{% assign noSimpleProductWithAttributesOnControlledStock = true -%}
						{% endif -%}
						{% if activeProduct.Availability.Status == 3 or noSimpleProductOnControlledStock or noSimpleProductWithAttributesOnControlledStock -%}
							{% if product.Clip == false and product.Batch == false -%}
								{% assign simpleProduct = true -%}
							{% endif -%}
							<div class="primary-buttons">
								{% if customer.HidePrices -%}
									<a aria-label="sign-in" {% if settings.signIn == "page" -%}href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}"{% else -%}class="show-login-popup-js"{% endif -%} rel="nofollow" title="{{ translations.SignIn }}">
										<div class="primary-action-button" style="min-height: auto;">
											<span class="primary-action-button__text">{{ translations.LogIn }}</span>
											<svg class="primary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
											</svg>
										</div>
									</a>
								{% elseif activeProduct.Availability.Status == 3 or noSimpleProductOnControlledStock or noSimpleProductWithAttributesOnControlledStock -%}
									<button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}?supplyId={{ product.Id }}" data-include="notify-about-availability">
										<span>{{ translations.NotifyAboutAvailability }}</span>
										<svg width="18" height="20">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
										</svg>
									</button>
									{% if customer.Authenticated and noSimpleProductWithAttributesOnControlledStock == false and tableView == false and canBuy == true -%}
									<button aria-label="{{ translations.AddToWishList }}" class="secondary-action-button wishlist {% if config.B2B == false -%} add-to-wishlist-js {% else -%} show-add-to-wishlist-popup-js {% endif -%}" data-product-id="{{product.Id}}">
										<svg class="secondary-action-button__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
										</svg>
									</button>
								{% endif -%}
								{% elseif noSimpleProductOnControlledStock and activeProduct.AskForPrice == true -%}
								<button aria-label="ask-for-price" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ url }}" data-include="ask-for-price">
									{{ translations.AskForPrice }}
									<svg class="primary-action-button__icon">
										<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
										</svg>
									</button>
								{% endif -%}
							</div>
						{% endif -%}

						{% assign noSimpleProduct = false -%}
						{% if noSimpleProductOnControlledStock == true or noSimpleProductWithAttributesOnControlledStock == true -%}
							{% assign noSimpleProduct = true -%}
						{% endif -%}

						{% unless customer.HidePrices -%}
							<div class="secondary-buttons">
								{% if settings.inquiries == 'yes' and config.B2B and canBuy and activeProduct.AskForPrice == false -%}
									{% if activeProduct.Availability.Status != 3 and noProductOnControlledStock == false -%}
										<button aria-label="{{translations.ToInquiry}}" class="secondary-action-button add-to-inquiry-js add-to-cart-button-js parent-container-reload-js {% if tableView -%} add-many-products-js {% else -%} add-to-cart-update-client-area-js {% endif -%}">
											<span class="secondary-action-button__text">{{translations.ToInquiry}}</span>
											<svg class="secondary-action-button__icon">
												<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
											</svg>
										</button>
									{% endif -%}
								{% endif -%}
								{% if settings.compareProducts == 'yes' -%}
									<button class="secondary-action-button {% if isInComparison == false -%}add-to-comparison-js{% else -%}remove-from-comparison-js{% endif -%}" data-product-id="{{product.Id}}">
										<span class="secondary-action-button__text">
											{% if isInComparison == false -%}
												{{translations.Compare}}
											{% else -%}
												{{translations.Delete}}
											{% endif -%}
										</span>
										<svg class="secondary-action-button__icon">
											<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#balance-scale-left-{{settings.iconStyle}}"></use>
										</svg>
									</button>
								{% endif -%}
							</div>
						{% endunless -%}
					</div>
					
					{% include 'partials/product/product-actions.html' -%}
				</div>
			</div>
		{% endif -%}
		
		{% include 'partials/product/product-info.html' -%}
	</div>
</div>

{% include 'partials/common/image-rotate-popup.html' -%}

{% include 'partials/product/sticky-navigation-bar.html' -%}

{% include 'partials/product/bottom-section.html' -%}

{% include 'partials/product/related-products.html' -%}
`